import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import * as _ from "lodash";
import { getTranslate } from "react-localize-redux";
import moment from "moment";
import ReactDOM from "react-dom";
import classnames from "classnames";
import axios from "axios";
import Select from "react-select";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  TabContent,
  TabPane,
  Nav,
  NavItem,
  NavLink,
} from "reactstrap";
import Form from "react-validation/build/form";
import Input from "react-validation/build/input";
import validator from "validator";
import ReactTooltip from "react-tooltip";
/* global $ */
import ReactJson from "react-json-view";
import { Grid, Actions } from "react-redux-grid";
import { ConfigReportsGrid } from "../Reports/configReportsGrid";
import {
  configActions,
  msgActions,
  reportActions,
} from "../../../redux/actions";
import { store } from "../../../redux/store";

import { SaveCustomerConfirm } from "./SaveCustomerConfirm";

import "./Configuration.css";

import {
  legacyIdsColumns,
  projectsColumns,
  contactsColumns,
  sendersColumns,
  handleEmailValidation,
  handleRequiredFieldValidation,
} from "./config-grid-editing";

window.legSysNameInputRefList = {};
window.dummyLastRowsSysNameInput = {};
window.legUserNameInputRefList = {};
window.dummyLastRowsUserNameInput = {};
window.projIdInputRefList = {};
window.dummyLastRowsIdInputProj = {};
window.projNameInputRefList = {};
window.dummyLastRowsNameInputProj = {};
window.projDescInputRefList = {};
window.dummyLastRowsDescInputProj = {};
window.contNameInputRefList = {};
window.dummyLastRowsNameInputContact = {};
window.contEmailInputRefList = {};
window.dummyLastRowsEmailInputContact = {};
window.dummyLastRowsNotesInputContact = {};
window.contNotesInputRefList = {};
window.senderIdInputRefList = {};
window.dummyLastRowsIdInputSender = {};
window.senderCompanyNameInputRefList = {};
window.dummyLastRowsCompanyNameInputSender = {};
window.senderCustomerCodeInputRefList = {};
window.dummyLastRowsCustomerCodeInputSender = {};

let duplicatedRowIndexesLegecyIds = [];
let duplicatedRowIndexesProjects = [];
let duplicatedRowIndexesContacts = [];
let duplicatedRowIndexesSenders = [];

class Configuration extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      validCountry: true,
      validLanguage: true,
      showLegacyIdsListError: false,
      legacyIdsErrors: {},

      showProjectsListError: false,
      projectsErrors: {},

      showContactsListError: false,
      contactsErrors: {},

      showSendersListError: false,
      sendersErrors: {},

      generalInfoErrorNum: 0,
      sendersErrorNum: 0,

      modalHistory: false,
      selectedCustomerHistory: [],

      fullEventModal: false,
      eventJsonObj: {},

      modalBind: false,

      bindUpdatedEventCount: 0,
      bindUpdatedDashboardVolumeCount: 0,
      bindUpdatedFilebucketCount: 0,
      bindUpdatedParkedDocumentCount: 0,
      bindUpdatedDobsCount: 0,

      enableBindDataDialog: false,

      showLoaderMask: false,
      loaderMaskText: "",
    };

    const me = this;
    if (legacyIdsColumns.length === 2) {
      legacyIdsColumns.push({
        name: "",
        hidden: true,
        editable: true,
        width: "33px",
        dataIndex: "_key",
        editor: ({ column, columns, value, stateKey, store, rowId }) => {
          if (value && value !== "cm93LTE=") {
            return (
              <span
                className="fa fa-times"
                onClick={(e) => {
                  me.handleDeleteLegecyId(column, value, rowId);
                }}
              />
            );
          } else {
            return <span />;
          }
        },
      });
    }

    if (projectsColumns.length === 3) {
      projectsColumns.push({
        name: "",
        hidden: true,
        editable: true,
        width: "33px",
        dataIndex: "_key",
        editor: ({ column, columns, value, stateKey, store, rowId }) => {
          if (value && value !== "cm93LTE=") {
            return (
              <span
                className="fa fa-times"
                onClick={(e) => {
                  me.handleDeleteProject(column, value, rowId);
                }}
              />
            );
          } else {
            return <span />;
          }
        },
      });
    }

    if (contactsColumns.length === 3) {
      contactsColumns.push({
        name: "",
        hidden: true,
        editable: true,
        width: "33px",
        dataIndex: "_key",
        editor: ({ column, columns, value, stateKey, store, rowId }) => {
          if (value && value !== "cm93LTE=") {
            return (
              <span
                className="fa fa-times"
                onClick={(e) => {
                  me.handleDeleteContact(column, value, rowId);
                }}
              />
            );
          } else {
            return <span />;
          }
        },
      });
    }

    if (sendersColumns.length === 3) {
      sendersColumns.push({
        name: "",
        hidden: true,
        editable: true,
        width: "33px",
        dataIndex: "_key",
        editor: ({ column, columns, value, stateKey, store, rowId }) => {
          if (value && value !== "cm93LTE=") {
            return (
              <span
                className="fa fa-times"
                onClick={(e) => {
                  me.handleDeleteSender(column, value, rowId);
                }}
              />
            );
          } else {
            return <span />;
          }
        },
      });
    }
  }

  toggleModalConfirm = () => {
    this.props.dispatch(
      configActions.toggleModalConfirm(!this.props.config.modalConfirm)
    );
  };

  handleHashChange = (e) => {
    if (e.newURL && e.newURL.includes && e.newURL.includes("#/smart-search")) {
      const { dispatch } = this.props;
      let me = this;
      if (window.isEditingMode) {
        dispatch(configActions.toggleModalConfirm(true));
        dispatch(
          configActions.setConfirmDialogHandler(function () {
            dispatch(configActions.toggleModalConfirm(false));
            me.applyViewMode();
            setTimeout(function () {
              var _parts = e.newURL.split("#");
              if (_parts.length > 1) {
                me.props.history.push(_parts[1]);
              }
            }, 200);
          })
        );
        me.props.history.push("/customers");
      }
    }
    window.removeEventListener("hashchange", this.handleHashChange, false);
  };

  onSearchTextFieldChange = (e) => {
    const { dispatch, config } = this.props;
    if (config.editMode || config.isNewCustomer) {
      dispatch(configActions.toggleModalConfirm(true));
      var _val = e.target.value;
      dispatch(
        configActions.setConfirmDialogHandler(function () {
          dispatch(configActions.setFilterStr(_val));
          dispatch(configActions.resetSelectedConfigCustomer());
          dispatch(configActions.setNewCustomerStatus(false));
          dispatch(configActions.setCustomerEditMode(false));
          window.isEditingMode = false;
          dispatch(configActions.toggleModalConfirm(false));
        })
      );
    } else {
      dispatch(configActions.setFilterStr(e.target.value));
      dispatch(configActions.resetSelectedConfigCustomer());
    }
  };

  showLoader = (loaderMaskText) => {
    this.setState({
      showLoaderMask: true,
      loaderMaskText,
    });
  };

  hideLoader = () => {
    this.setState({
      showLoaderMask: false,
      loaderMaskText: "",
    });
  };

  handleSelectCustomer = (item, forceSelection, afterSave) => {
    const { dispatch, config } = this.props;
    if (
      !!forceSelection ||
      !config.selectedCustomerInfo ||
      config.selectedCustomerInfo.GlobalId !== item.globalId
    ) {
      if (!afterSave && (config.editMode || config.isNewCustomer)) {
        dispatch(configActions.toggleModalConfirm(true));
        const me = this;
        dispatch(
          configActions.setConfirmDialogHandler(function () {
            me.clearAllGridsData();
            dispatch(
              configActions.getProjectsByCustomerId(item.globalId, "configView")
            );
            dispatch(
              configActions.getReportsByCustomerId(
                item.globalId,
                1,
                config.selCustomerConfigReportsSize
              )
            );
            me.applyViewMode();
            dispatch(configActions.toggleModalConfirm(false));
          })
        );
      } else {
        this.clearAllGridsData();

        const selectedCustomer = config.selectedCustomerInfo || item;

        this.syncGridDataSet({ data: selectedCustomer });

        dispatch(
          configActions.getProjectsByCustomerId(item.globalId, "configView")
        );
        dispatch(
          configActions.getReportsByCustomerId(
            item.globalId,
            1,
            config.selCustomerConfigReportsSize
          )
        );
        this.applyViewMode();
      }
    }
  };

  clearAllGridsData = () => {
    this.setState({
      validCountry: true,
      validLanguage: true,
    });
    store.dispatch(
      Actions.GridActions.setData({
        stateKey: "customerLegacyIds",
        data: [],
        editMode: true,
      })
    );
    store.dispatch(
      Actions.EditorActions.removeRow({
        stateKey: "customerLegacyIds",
        rowIndex: 0,
      })
    );
    store.dispatch(
      Actions.GridActions.setData({
        stateKey: "customerProjects",
        data: [],
        editMode: true,
      })
    );
    store.dispatch(
      Actions.EditorActions.removeRow({
        stateKey: "customerProjects",
        rowIndex: 0,
      })
    );
    store.dispatch(
      Actions.GridActions.setData({
        stateKey: "customerSenders",
        data: [],
        editMode: true,
      })
    );
    store.dispatch(
      Actions.EditorActions.removeRow({
        stateKey: "customerSenders",
        rowIndex: 0,
      })
    );
    store.dispatch(
      Actions.GridActions.setData({
        stateKey: "customerContacts",
        data: [],
        editMode: true,
      })
    );
    store.dispatch(
      Actions.EditorActions.removeRow({
        stateKey: "customerContacts",
        rowIndex: 0,
      })
    );
    setTimeout(function () {
      window.legSysNameInputRefList = {};
      window.dummyLastRowsSysNameInput = {};

      window.legUserNameInputRefList = {};
      window.dummyLastRowsUserNameInput = {};

      window.projIdInputRefList = {};
      window.dummyLastRowsIdInputProj = {};

      window.projNameInputRefList = {};
      window.dummyLastRowsNameInputProj = {};

      window.projDescInputRefList = {};
      window.dummyLastRowsDescInputProj = {};

      window.contNameInputRefList = {};
      window.dummyLastRowsNameInputContact = {};

      window.contEmailInputRefList = {};
      window.dummyLastRowsEmailInputContact = {};

      window.contNotesInputRefList = {};
      window.dummyLastRowsNotesInputContact = {};

      window.senderIdInputRefList = {};
      window.dummyLastRowsIdInputSender = {};

      window.senderCompanyNameInputRefList = {};
      window.dummyLastRowsCompanyNameInputSender = {};

      window.senderCustomerCodeInputRefList = {};
      window.dummyLastRowsCustomerCodeInputSender = {};
    }, 500);
  };

  updateSeleCusState = (event) => {
    const field = event.target.name;
    const { dispatch, config } = this.props;
    let me = this;
    if (field === "act") {
      if (this.props.config.selectedCustomerInfo) {
        if (event.target.checked) {
          dispatch(
            configActions.activateCustomer(config.selectedCustomerInfo._id)
          ).then((responseData) => {
            if (responseData.error) {
              dispatch(
                msgActions.error(
                  "Activating Customer failure",
                  responseData.error,
                  null,
                  true
                )
              );
            } else {
              dispatch(
                msgActions.success(
                  "Activating Customer",
                  "Customer saved successfully"
                )
              );
              me.showLoader("Loading customers...");
              dispatch(
                configActions.getActiveCustomers(true, store.getState())
              );
              dispatch(configActions.getAllCustomers()).then(() =>
                me.hideLoader()
              );
              dispatch(
                configActions.getProjectsByCustomerId(
                  config.selectedCustomerInfo.GlobalId,
                  "configView"
                )
              );
            }
          });
        } else {
          dispatch(
            configActions.deactivateCustomer(config.selectedCustomerInfo._id)
          ).then((responseData) => {
            if (responseData.error) {
              dispatch(
                msgActions.error(
                  "Deactivating Customer failure",
                  responseData.error,
                  null,
                  true
                )
              );
            } else {
              dispatch(
                msgActions.success(
                  "Deactivating Customer",
                  "Customer saved successfully"
                )
              );
              me.showLoader("Loading customers...");
              dispatch(
                configActions.getActiveCustomers(true, store.getState())
              );
              dispatch(configActions.getAllCustomers()).then(() =>
                me.hideLoader()
              );
            }
          });
        }
      }
    } else {
      if (config.isNewCustomer) {
        this.props.dispatch(
          configActions.updateNewCustomerField(field, event.target.value)
        );
      } else if (config.selectedCustomerInfo) {
        this.props.dispatch(
          configActions.updateSeleCustomerField(field, event.target.value)
        );
      }
    }
  };

  updateSeleCusParentId = (selectedItem) => {
    if (this.props.config.isNewCustomer) {
      this.props.dispatch(
        configActions.updateNewCustomerField(
          "parentId",
          selectedItem && selectedItem.value
        )
      );
    } else if (this.props.config.selectedCustomerInfo) {
      this.props.dispatch(
        configActions.updateSeleCustomerField(
          "parentId",
          selectedItem && selectedItem.value
        )
      );
    }
  };

  updateSeleCusCountryState = (selectedItem) => {
    if (selectedItem && selectedItem.value) {
      this.setState({
        validCountry: true,
      });
    } else {
      this.setState({
        validCountry: false,
      });
    }
    if (this.props.config.isNewCustomer) {
      this.props.dispatch(
        configActions.updateNewCustomerField(
          "Country",
          selectedItem && selectedItem.value
        )
      );
    } else if (this.props.config.selectedCustomerInfo) {
      this.props.dispatch(
        configActions.updateSeleCustomerField(
          "Country",
          selectedItem && selectedItem.value
        )
      );
    }
  };

  updateSeleCusLangState = (selectedItem) => {
    if (selectedItem && selectedItem.value) {
      this.setState({
        validLanguage: true,
      });
    } else {
      this.setState({
        validLanguage: false,
      });
    }
    if (this.props.config.isNewCustomer) {
      this.props.dispatch(
        configActions.updateNewCustomerField(
          "Language",
          selectedItem && selectedItem.value
        )
      );
    } else if (this.props.config.selectedCustomerInfo) {
      this.props.dispatch(
        configActions.updateSeleCustomerField(
          "Language",
          selectedItem && selectedItem.value
        )
      );
    }
  };

  isValidForm = (data) => {
    let valid = true;
    let generalInfoErrorNum = 0;
    let sendersErrorNum = 0;
    if (!data.GlobalId || !(data.GlobalId.length > 0)) {
      valid = false;
      generalInfoErrorNum++;
    }

    if (!data.Name || !(data.Name.length > 0)) {
      valid = false;
      generalInfoErrorNum++;
    }

    if (!data.Country || !(data.Country.length > 0)) {
      valid = false;
      generalInfoErrorNum++;
      this.setState({
        validCountry: false,
      });
    }

    if (!data.Language || !(data.Language.length > 0)) {
      valid = false;
      generalInfoErrorNum++;
      this.setState({
        validLanguage: false,
      });
    }

    let legacyIdsErrors = {};
    let testLegacyIdsObject = [];
    duplicatedRowIndexesLegecyIds = [];
    let _foundIdx;
    var i = 0;
    for (i = 0; i < data.LegacyIds.length; i++) {
      let _legacyId = data.LegacyIds[i];
      if (!_legacyId.systemname || !(_legacyId.systemname.length > 0)) {
        legacyIdsErrors["systemname"] =
          "LegacyIds' system should be string of selected from the available values";
        generalInfoErrorNum++;
      }
      if (
        !_legacyId.username ||
        !(_legacyId.username.length > 0) ||
        !(_legacyId.username.length < 20)
      ) {
        legacyIdsErrors["username"] =
          "LegacyIds' username should be string of max 20 length";
        generalInfoErrorNum++;
      }
      var foundLegId = testLegacyIdsObject.filter(function (obj) {
        return (
          obj.systemname === _legacyId.systemname &&
          obj.username === _legacyId.username
        );
      })[0];
      if (foundLegId) {
        _foundIdx = data.LegacyIds.indexOf(foundLegId);
        if (!duplicatedRowIndexesLegecyIds.includes(_foundIdx)) {
          duplicatedRowIndexesLegecyIds.push(_foundIdx);
        }
        duplicatedRowIndexesLegecyIds.push(i);
        legacyIdsErrors["DuplicatedRow"] =
          "LegacyIds' row entries should not be duplicated";
        generalInfoErrorNum++;
      } else {
        testLegacyIdsObject.push(_legacyId);
      }
    }
    if (
      typeof legacyIdsErrors["systemname"] === "undefined" &&
      typeof legacyIdsErrors["username"] === "undefined" &&
      typeof legacyIdsErrors["DuplicatedRow"] === "undefined"
    ) {
      this.setState({
        showLegacyIdsListError: false,
        legacyIdsErrors: {},
      });
    } else {
      this.setState({
        showLegacyIdsListError: true,
        legacyIdsErrors,
      });
      valid = false;
    }

    let projectsErrors = {};
    let testProjectsObject = [];
    duplicatedRowIndexesProjects = [];
    for (i = 0; i < data.Projects.length; i++) {
      let _project = data.Projects[i];
      if (
        !_project.projectId ||
        !(_project.projectId.length > 0) ||
        !(_project.projectId.length <= 20)
      ) {
        projectsErrors["projectId"] =
          "Flow ID should be string of max 20 length";
        generalInfoErrorNum++;
      }
      if (
        !_project.name ||
        !(_project.name.length > 0) ||
        !(_project.name.length <= 50)
      ) {
        projectsErrors["name"] = "Flow' name should be string of max 50 length";
        generalInfoErrorNum++;
      }
      var foundProj = testProjectsObject.filter(function (obj) {
        return (
          obj.projectId === _project.projectId && obj.name === _project.name
        );
      })[0];
      if (foundProj) {
        _foundIdx = data.Projects.indexOf(foundProj);
        if (!duplicatedRowIndexesProjects.includes(_foundIdx)) {
          duplicatedRowIndexesProjects.push(_foundIdx);
        }
        duplicatedRowIndexesProjects.push(i);
        projectsErrors["DuplicatedRow"] =
          "Flows' row entries should not be duplicated";
        generalInfoErrorNum++;
      } else {
        testProjectsObject.push(_project);
      }
    }

    if (
      typeof projectsErrors["projectId"] === "undefined" &&
      typeof projectsErrors["name"] === "undefined" &&
      typeof projectsErrors["DuplicatedRow"] === "undefined"
    ) {
      this.setState({
        showProjectsListError: false,
        projectsErrors: {},
      });
    } else {
      this.setState({
        showProjectsListError: true,
        projectsErrors,
      });
      valid = false;
    }

    let contactsErrors = {};
    let testContactsObject = [];
    duplicatedRowIndexesContacts = [];
    for (i = 0; i < data.Contacts.length; i++) {
      let _contact = data.Contacts[i];
      if (
        !_contact.Name ||
        !(_contact.Name.length > 0) ||
        !(_contact.Name.length < 50)
      ) {
        contactsErrors["Name"] =
          "Contacts' Name should be string of max 50 length";
        generalInfoErrorNum++;
      }
      if (!_contact.Email || !validator.isEmail(_contact.Email)) {
        contactsErrors["Email"] =
          "Contacts' Email should be valid Email address";
        generalInfoErrorNum++;
      }
      var foundContact = testContactsObject.filter(function (obj) {
        return obj.Name === _contact.Name && obj.Email === _contact.Email;
      })[0];
      if (foundContact) {
        _foundIdx = data.Contacts.indexOf(foundContact);
        if (!duplicatedRowIndexesContacts.includes(_foundIdx)) {
          duplicatedRowIndexesContacts.push(_foundIdx);
        }
        duplicatedRowIndexesContacts.push(i);
        contactsErrors["DuplicatedRow"] =
          "Contacts' row entries should not be duplicated";
        generalInfoErrorNum++;
      } else {
        testContactsObject.push(_contact);
      }
    }

    if (
      typeof contactsErrors["Name"] === "undefined" &&
      typeof contactsErrors["Email"] === "undefined" &&
      typeof contactsErrors["DuplicatedRow"] === "undefined"
    ) {
      this.setState({
        showContactsListError: false,
        contactsErrors: {},
      });
    } else {
      this.setState({
        showContactsListError: true,
        contactsErrors,
      });
      valid = false;
    }

    let sendersErrors = {};
    let testSenderIdObject = [];
    let testSenderCustomerCodeObject = [];
    duplicatedRowIndexesSenders = [];
    for (i = 0; i < data.Senders.length; i++) {
      let _sender = data.Senders[i];
      if (
        !_sender.senderId ||
        !(_sender.senderId.length > 0) ||
        !(_sender.senderId.length < 20)
      ) {
        sendersErrors["senderId"] =
          "Sender ID should be string of max 20 length";
        sendersErrorNum++;
      }
      if (
        !_sender.senderCompanyName ||
        !(_sender.senderCompanyName.length > 0) ||
        !(_sender.senderCompanyName.length < 30)
      ) {
        sendersErrors["senderCompanyName"] =
          "Senders' company name should be string of max 30 length";
        sendersErrorNum++;
      }
      var foundSender = testSenderIdObject.filter(function (obj) {
        return (
          obj.senderId.toLowerCase &&
          _sender.senderId.toLowerCase &&
          obj.senderId.toLowerCase() === _sender.senderId.toLowerCase()
        );
      })[0];
      if (foundSender) {
        _foundIdx = data.Senders.indexOf(foundSender);
        if (!duplicatedRowIndexesSenders.includes(_foundIdx)) {
          duplicatedRowIndexesSenders.push(_foundIdx);
        }
        duplicatedRowIndexesSenders.push(i);
        sendersErrors["DuplicatedRowSenderId"] =
          "Sender id must be unique for one customer";

        sendersErrorNum++;
      } else {
        testSenderIdObject.push(_sender);
      }
      if (
        !!_sender.customerCode &&
        _sender.customerCode.toString().trim().length > 0
      ) {
        foundSender = testSenderCustomerCodeObject.filter(function (obj) {
          return obj.customerCode === _sender.customerCode;
        })[0];
        if (foundSender) {
          _foundIdx = data.Senders.indexOf(foundSender);
          if (!duplicatedRowIndexesSenders.includes(_foundIdx)) {
            duplicatedRowIndexesSenders.push(_foundIdx);
          }
          duplicatedRowIndexesSenders.push(i);
          sendersErrors["DuplicatedRowCustomerCode"] =
            "Sender's customer code must be unique for one customer";
          sendersErrorNum++;
        } else {
          testSenderCustomerCodeObject.push(_sender);
        }
      }
    }
    if (Object.keys(sendersErrors).length > 0) {
      this.setState({
        showSendersListError: true,
        sendersErrors,
      });
      valid = false;
    } else {
      this.setState({
        showSendersListError: false,
        sendersErrors: {},
      });
    }
    this.setState({
      generalInfoErrorNum,
      sendersErrorNum,
    });
    return valid;
  };

  handleSaveCustomer = (event) => {
    event.preventDefault();
    if (this.props.config.editMode || this.props.config.isNewCustomer) {
      this.saveCustomer();
    } else {
      this.applyEditMode();
    }
  };

  saveCustomer = (cb) => {
    this.form && this.form.validateAll();
    if (this.props.config.isNewCustomer) {
      let custLegacyIds = [];
      (
        store
          .getState()
          .dataSource.get("customerLegacyIds")
          .get("data")
          .toJS() || []
      ).forEach(function (item) {
        if (item.systemname || item.username.toString().trim()) {
          custLegacyIds.push({
            systemname: item.systemname,
            username: item.username.toString().trim(),
          });
        }
      });
      let custProjects = [];
      (
        store
          .getState()
          .dataSource.get("customerProjects")
          .get("data")
          .toJS() || []
      ).forEach(function (item) {
        if (
          item.projectId.toString().trim() ||
          item.name.toString().trim() ||
          item.description.toString().trim()
        ) {
          custProjects.push({
            projectId: item.projectId.toString().trim(),
            description: item.description.toString().trim(),
            name: item.name.toString().trim(),
          });
        }
      });
      let custContacts = [];
      (
        store
          .getState()
          .dataSource.get("customerContacts")
          .get("data")
          .toJS() || []
      ).forEach(function (item) {
        if (
          item.Name.toString().trim() ||
          item.Email.toString().trim() ||
          item.Notes.toString().trim()
        ) {
          custContacts.push({
            Name: item.Name.toString().trim(),
            Email: item.Email.toString().trim(),
            Notes: item.Notes.toString().trim(),
          });
        }
      });

      let custSenders = [];
      (
        store.getState().dataSource.get("customerSenders").get("data").toJS() ||
        []
      ).forEach(function (item) {
        if (
          item.senderId.toString().trim() ||
          item.senderCompanyName.toString().trim() ||
          item.customerCode.toString().trim()
        ) {
          custSenders.push({
            senderId: item.senderId.toString().trim(),
            senderCompanyName: item.senderCompanyName.toString().trim(),
            customerCode: !!item.customerCode.toString().trim()
              ? item.customerCode.toString().trim()
              : null,
          });
        }
      });
      let _newCustData = this.props.config.newCustomerData;
      let newCustomerInfo = Object.assign(
        {},
        {
          GlobalId: _newCustData.GlobalId.toString().trim(),
          Name: _newCustData.Name.toString().trim(),
          SNCId: _newCustData.SNCId.toString().trim(),
          sapId: (_newCustData.sapId || "").toString().trim(),
          parentId: _newCustData.parentId,
          Country: _newCustData.Country,
          Language: _newCustData.Language,
          LegacyIds: custLegacyIds,
          Projects: custProjects,
          Contacts: custContacts,
          Senders: custSenders,
        }
      );

      if (this.isValidForm(newCustomerInfo)) {
        const { dispatch } = this.props;
        let me = this;
        dispatch(configActions.insertCustomer(newCustomerInfo)).then(
          (responseData) => {
            if (responseData.error) {
              dispatch(
                msgActions.error(
                  "Saving new Customer failure",
                  responseData.error,
                  () => {
                    setTimeout(function () {
                      me.clearAllGridsData();
                      store.dispatch(
                        Actions.GridActions.setData({
                          stateKey: "customerLegacyIds",
                          data: newCustomerInfo.LegacyIds,
                          editMode: true,
                        })
                      );
                      store.dispatch(
                        Actions.GridActions.setData({
                          stateKey: "customerProjects",
                          data: newCustomerInfo.Projects,
                          editMode: true,
                        })
                      );
                      store.dispatch(
                        Actions.GridActions.setData({
                          stateKey: "customerContacts",
                          data: newCustomerInfo.Contacts,
                          editMode: true,
                        })
                      );
                      store.dispatch(
                        Actions.GridActions.setData({
                          stateKey: "customerSenders",
                          data: newCustomerInfo.Senders,
                          editMode: true,
                        })
                      );
                    }, 200);
                  },
                  true
                )
              );
            } else {
              dispatch(
                msgActions.success(
                  "Saving new Customer",
                  "Customer saved successfully"
                )
              );
              if (cb) {
                cb();
              } else {
                dispatch(configActions.setNewCustomerStatus(false));
                window.isEditingMode = false;
                me.handleSelectCustomer(
                  { globalId: newCustomerInfo.GlobalId },
                  true,
                  true
                );
                me.showLoader("Loading customers...");
                dispatch(
                  configActions.getActiveCustomers(true, store.getState())
                );
                dispatch(configActions.getAllCustomers()).then(() =>
                  me.hideLoader()
                );
                if (me.props.config.modalConfirm) {
                  me.toggleModalConfirm();
                }
              }
            }
          }
        );
      }
    } else if (this.props.config.selectedCustomerInfo) {
      let _selectedCustomerInfo = this.props.config.selectedCustomerInfo;

      const customerLegacyIdsSource = store
        .getState()
        .dataSource.get("customerLegacyIds");
      let custLegacyIds = [];
      if (
        customerLegacyIdsSource &&
        customerLegacyIdsSource.get("data") &&
        customerLegacyIdsSource.get("data").toJS() &&
        customerLegacyIdsSource.get("data").toJS().length > 0
      ) {
        (customerLegacyIdsSource.get("data").toJS() || []).forEach((item) => {
          if (item.systemname || item.username.toString().trim()) {
            custLegacyIds.push({
              systemname: item.systemname,
              username: item.username.toString().trim(),
            });
          }
        });
      } else {
        custLegacyIds = [];
      }

      const customerProjectsSource = store
        .getState()
        .dataSource.get("customerProjects");
      let custProjects = [];
      if (
        customerProjectsSource &&
        customerProjectsSource.get("data") &&
        customerProjectsSource.get("data").toJS() &&
        customerProjectsSource.get("data").toJS().length > 0
      ) {
        (customerProjectsSource.get("data").toJS() || []).forEach((item) => {
          if (
            item.projectId.toString().trim() ||
            item.name.toString().trim() ||
            item.description.toString().trim()
          ) {
            custProjects.push({
              projectId: item.projectId.toString().trim(),
              description: item.description.toString().trim(),
              name: item.name.toString().trim(),
            });
          }
        });
      } else {
        custProjects = [];
      }

      const customerContactsSource = store
        .getState()
        .dataSource.get("customerContacts");
      let custContacts = [];
      if (
        customerContactsSource &&
        customerContactsSource.get("data") &&
        customerContactsSource.get("data").toJS() &&
        customerContactsSource.get("data").toJS().length > 0
      ) {
        (customerContactsSource.get("data").toJS() || []).forEach((item) => {
          if (
            item.Name.toString().trim() ||
            item.Email.toString().trim() ||
            item.Notes.toString().trim()
          ) {
            custContacts.push({
              Name: item.Name.toString().trim(),
              Email: item.Email.toString().trim(),
              Notes: item.Notes.toString().trim(),
            });
          }
        });
      } else {
        custContacts = [];
      }

      const customerSendersSource = store
        .getState()
        .dataSource.get("customerSenders");
      let custSenders = [];
      if (
        customerSendersSource &&
        customerSendersSource.get("data") &&
        customerSendersSource.get("data").toJS() &&
        customerSendersSource.get("data").toJS().length > 0
      ) {
        (customerSendersSource.get("data").toJS() || []).forEach((item) => {
          if (
            item.senderId.toString().trim() ||
            item.senderCompanyName.toString().trim() ||
            item.customerCode.toString().trim()
          ) {
            custSenders.push({
              senderId: item.senderId.toString().trim(),
              senderCompanyName: item.senderCompanyName.toString().trim(),
              customerCode:
                !!item.customerCode && !!item.customerCode.toString().trim()
                  ? item.customerCode.toString().trim()
                  : null,
            });
          }
        });
      } else {
        custSenders = [];
      }

      let customerInfo = Object.assign(
        {},
        {
          GlobalId: this.props.config.selectedCustomerGlobalId
            .toString()
            .trim(),
          Name: this.props.config.selectedCustomerName.toString().trim(),
          SNCId: _selectedCustomerInfo.SNCId.toString().trim(),
          sapId: (_selectedCustomerInfo.sapId || "").toString().trim(),
          parentId: _selectedCustomerInfo.parentId,
          Country: _selectedCustomerInfo.Country,
          Language: _selectedCustomerInfo.Language,

          LastUpdated: _selectedCustomerInfo.LastUpdated,
          LastUpdatedBy: _selectedCustomerInfo.LastUpdatedBy,
          act: _selectedCustomerInfo.act,
          uc: _selectedCustomerInfo.uc,
          _id: _selectedCustomerInfo._id,

          LegacyIds: custLegacyIds,
          Projects: custProjects,
          Contacts: custContacts,
          Senders: custSenders,
        }
      );

      if (this.isValidForm(customerInfo)) {
        const { dispatch } = this.props;
        let me = this;

        me.showLoader("Loading customers...");

        dispatch(configActions.updateCustomer(customerInfo)).then(
          async (responseData) => {
            if (responseData.error) {
              dispatch(
                msgActions.error(
                  "Saving Customer failure",
                  responseData.error,
                  () => {},
                  true
                )
              );

              me.hideLoader();
            } else {
              if (cb) {
                cb();
              } else {
                await Promise.all([
                  dispatch(
                      configActions.getActiveCustomers(true, store.getState())
                  ),
                  dispatch(configActions.getAllCustomers())
                ]);

                me.handleSelectCustomer(
                  { globalId: customerInfo.GlobalId },
                  true,
                  true
                );

                dispatch(
                    msgActions.success(
                        "Saving Customer",
                        "Customer saved successfully"
                    )
                );

                me.hideLoader();

                if (me.props.config.modalConfirm) {
                  me.toggleModalConfirm();
                }
              }
            }
          }
      )
          .catch(() => me.hideLoader());
      } else {
        var prop;
        for (prop in window.legSysNameInputRefList) {
          handleRequiredFieldValidation(prop, {
            target: ReactDOM.findDOMNode(window.legSysNameInputRefList[prop]),
          });
        }
        let _tempDummiesArray = Object.entries(
          window.dummyLastRowsSysNameInput
        );
        if (_tempDummiesArray.length > 1) {
          _tempDummiesArray.slice(0, -1).forEach(function (item) {
            handleRequiredFieldValidation(item[0], {
              target: ReactDOM.findDOMNode(item[1]),
            });
          });
        }

        for (prop in window.legUserNameInputRefList) {
          handleRequiredFieldValidation(prop, {
            target: ReactDOM.findDOMNode(window.legUserNameInputRefList[prop]),
          });
        }
        _tempDummiesArray = Object.entries(window.dummyLastRowsUserNameInput);
        if (_tempDummiesArray.length > 1) {
          _tempDummiesArray.slice(0, -1).forEach(function (item) {
            handleRequiredFieldValidation(item[0], {
              target: ReactDOM.findDOMNode(item[1]),
            });
          });
        }

        for (prop in window.projIdInputRefList) {
          handleRequiredFieldValidation(prop, {
            target: ReactDOM.findDOMNode(window.projIdInputRefList[prop]),
          });
        }
        _tempDummiesArray = Object.entries(window.dummyLastRowsIdInputProj);
        if (_tempDummiesArray.length > 1) {
          _tempDummiesArray.slice(0, -1).forEach(function (item) {
            handleRequiredFieldValidation(item[0], {
              target: ReactDOM.findDOMNode(item[1]),
            });
          });
        }

        for (prop in window.projNameInputRefList) {
          handleRequiredFieldValidation(prop, {
            target: ReactDOM.findDOMNode(window.projNameInputRefList[prop]),
          });
        }
        _tempDummiesArray = Object.entries(window.dummyLastRowsNameInputProj);
        if (_tempDummiesArray.length > 1) {
          _tempDummiesArray.slice(0, -1).forEach(function (item) {
            handleRequiredFieldValidation(item[0], {
              target: ReactDOM.findDOMNode(item[1]),
            });
          });
        }

        for (prop in window.contNameInputRefList) {
          handleRequiredFieldValidation(prop, {
            target: ReactDOM.findDOMNode(window.contNameInputRefList[prop]),
          });
        }
        _tempDummiesArray = Object.entries(
          window.dummyLastRowsNameInputContact
        );
        if (_tempDummiesArray.length > 1) {
          _tempDummiesArray.slice(0, -1).forEach(function (item) {
            handleRequiredFieldValidation(item[0], {
              target: ReactDOM.findDOMNode(item[1]),
            });
          });
        }
        for (prop in window.contEmailInputRefList) {
          handleEmailValidation(prop, {
            target: ReactDOM.findDOMNode(window.contEmailInputRefList[prop]),
          });
        }
        _tempDummiesArray = Object.entries(
          window.dummyLastRowsEmailInputContact
        );
        if (_tempDummiesArray.length > 1) {
          _tempDummiesArray.slice(0, -1).forEach(function (item) {
            handleEmailValidation(item[0], {
              target: ReactDOM.findDOMNode(item[1]),
            });
          });
        }

        for (prop in window.senderIdInputRefList) {
          handleRequiredFieldValidation(prop, {
            target: ReactDOM.findDOMNode(window.senderIdInputRefList[prop]),
          });
        }
        _tempDummiesArray = Object.entries(window.dummyLastRowsIdInputSender);
        if (_tempDummiesArray.length > 1) {
          _tempDummiesArray.slice(0, -1).forEach(function (item) {
            handleRequiredFieldValidation(item[0], {
              target: ReactDOM.findDOMNode(item[1]),
            });
          });
        }

        for (prop in window.senderCompanyNameInputRefList) {
          handleRequiredFieldValidation(prop, {
            target: ReactDOM.findDOMNode(
              window.senderCompanyNameInputRefList[prop]
            ),
          });
        }
        _tempDummiesArray = Object.entries(
          window.dummyLastRowsCompanyNameInputSender
        );
        if (_tempDummiesArray.length > 1) {
          _tempDummiesArray.slice(0, -1).forEach(function (item) {
            handleRequiredFieldValidation(item[0], {
              target: ReactDOM.findDOMNode(item[1]),
            });
          });
        }

        if (duplicatedRowIndexesLegecyIds.length) {
          let _rows = $(ReactDOM.findDOMNode(this.legacyIdsGrid)).find(
            ".react-grid-row"
          );
          _rows.each((i, dom) => {
            let e = $(dom);
            if (duplicatedRowIndexesLegecyIds.includes(i)) {
              if (!e.hasClass("invalid-row")) {
                e.addClass("invalid-row");
              }
            } else {
              e.removeClass("invalid-row");
            }
          });
        } else {
          let _rows = $(ReactDOM.findDOMNode(this.legacyIdsGrid)).find(
            ".react-grid-row"
          );
          _rows.each((i, dom) => {
            let e = $(dom);
            e.removeClass("invalid-row");
          });
        }

        if (duplicatedRowIndexesProjects.length) {
          let _rows = $(ReactDOM.findDOMNode(this.projectsGrid)).find(
            ".react-grid-row"
          );
          _rows.each((i, dom) => {
            let e = $(dom);
            if (duplicatedRowIndexesProjects.includes(i)) {
              if (!e.hasClass("invalid-row")) {
                e.addClass("invalid-row");
              }
            } else {
              e.removeClass("invalid-row");
            }
          });
        } else {
          let _rows = $(ReactDOM.findDOMNode(this.projectsGrid)).find(
            ".react-grid-row"
          );
          _rows.each((i, dom) => {
            let e = $(dom);
            e.removeClass("invalid-row");
          });
        }

        if (duplicatedRowIndexesContacts.length) {
          let _rows = $(ReactDOM.findDOMNode(this.contactsGrid)).find(
            ".react-grid-row"
          );
          _rows.each((i, dom) => {
            let e = $(dom);
            if (duplicatedRowIndexesContacts.includes(i)) {
              if (!e.hasClass("invalid-row")) {
                e.addClass("invalid-row");
              }
            } else {
              e.removeClass("invalid-row");
            }
          });
        } else {
          let _rows = $(ReactDOM.findDOMNode(this.contactsGrid)).find(
            ".react-grid-row"
          );
          _rows.each((i, dom) => {
            let e = $(dom);
            e.removeClass("invalid-row");
          });
        }

        if (duplicatedRowIndexesSenders.length) {
          let _rows = $(ReactDOM.findDOMNode(this.sendersGrid)).find(
            ".react-grid-row"
          );
          _rows.each((i, dom) => {
            let e = $(dom);
            if (duplicatedRowIndexesSenders.includes(i)) {
              if (!e.hasClass("invalid-row")) {
                e.addClass("invalid-row");
              }
            } else {
              e.removeClass("invalid-row");
            }
          });
        } else {
          let _rows = $(ReactDOM.findDOMNode(this.sendersGrid)).find(
            ".react-grid-row"
          );
          _rows.each((i, dom) => {
            let e = $(dom);
            e.removeClass("invalid-row");
          });
        }
      }
    }
  };

  applyViewMode = () => {
    let columns = legacyIdsColumns.map((item) => {
      if (item.name === "") {
        return { ...item, hidden: true };
      } else {
        return { ...item, editable: false };
      }
    });
    store.dispatch(
      Actions.GridActions.setColumns({
        stateKey: "customerLegacyIds",
        stateful: false,
        columns,
      })
    );
    let columnsProj = projectsColumns.map((item) => {
      if (item.name === "") {
        return { ...item, hidden: true };
      } else {
        return { ...item, editable: false };
      }
    });
    store.dispatch(
      Actions.GridActions.setColumns({
        stateKey: "customerProjects",
        stateful: false,
        columns: columnsProj,
      })
    );

    let columnsContact = contactsColumns.map((item) => {
      if (item.name === "") {
        return { ...item, hidden: true };
      } else {
        return { ...item, editable: false };
      }
    });
    store.dispatch(
      Actions.GridActions.setColumns({
        stateKey: "customerContacts",
        stateful: false,
        columns: columnsContact,
      })
    );
    let columnsSender = sendersColumns.map((item) => {
      if (item.name === "") {
        return { ...item, hidden: true };
      } else {
        return { ...item, editable: false };
      }
    });
    store.dispatch(
      Actions.GridActions.setColumns({
        stateKey: "customerSenders",
        stateful: false,
        columns: columnsSender,
      })
    );
    this.props.dispatch(configActions.setNewCustomerStatus(false));
    this.props.dispatch(configActions.setCustomerEditMode(false));

    this.setState({
      validCountry: true,
      validLanguage: true,
      showLegacyIdsListError: false,
      legacyIdsErrors: {},

      showProjectsListError: false,
      projectsErrors: {},

      showContactsListError: false,
      contactsErrors: {},

      showSendersListError: false,
      sendersErrors: {},

      generalInfoErrorNum: 0,
      sendersErrorNum: 0,
    });
    window.isEditingMode = false;
  };

  applyEditMode = () => {
    const { dispatch, config } = this.props;
    if (config.activeTab === "1") {
      this.handleFirstTabGridsEdit();
    } else if (config.activeTab === "3") {
      this.handleThirdTabGridsEdit();
    }
    dispatch(configActions.setCustomerEditMode(true));
    window.isEditingMode = true;
  };

  handleFirstTabGridsEdit = () => {
    let columns = legacyIdsColumns.map((item) => {
      if (item.name === "") {
        return { ...item, hidden: false };
      } else {
        return { ...item, editable: true };
      }
    });
    let columnsProj = projectsColumns.map((item) => {
      if (item.name === "") {
        return { ...item, hidden: false };
      } else {
        return { ...item, editable: true };
      }
    });
    let columnsContact = contactsColumns.map((item) => {
      if (item.name === "") {
        return { ...item, hidden: false };
      } else {
        return { ...item, editable: true };
      }
    });

    setTimeout(function () {
      store.dispatch(
        Actions.GridActions.setColumns({
          stateKey: "customerLegacyIds",
          stateful: false,
          columns,
        })
      );
      let _index = store
        .getState()
        .dataSource.get("customerLegacyIds")
        .get("data").size;
      store.dispatch(
        Actions.GridActions.insertRow({
          stateKey: "customerLegacyIds",
          index: _index,
          data: {
            systemname: "",
            username: "",
          },
        })
      );

      store.dispatch(
        Actions.GridActions.setColumns({
          stateKey: "customerProjects",
          stateful: false,
          columns: columnsProj,
        })
      );
      let _indexProj = store
        .getState()
        .dataSource.get("customerProjects")
        .get("data").size;
      store.dispatch(
        Actions.GridActions.insertRow({
          stateKey: "customerProjects",
          index: _indexProj,
          data: {
            projectId: "",
            name: "",
            description: "",
          },
        })
      );

      store.dispatch(
        Actions.GridActions.setColumns({
          stateKey: "customerContacts",
          stateful: false,
          columns: columnsContact,
        })
      );
      let _indexContact = store
        .getState()
        .dataSource.get("customerContacts")
        .get("data").size;
      store.dispatch(
        Actions.GridActions.insertRow({
          stateKey: "customerContacts",
          index: _indexContact,
          data: {
            Name: "",
            Email: "",
            Notes: "",
          },
        })
      );
    }, 700);
  };

  handleThirdTabGridsEdit = () => {
    let columnsSender = sendersColumns.map((item) => {
      if (item.name === "") {
        return { ...item, hidden: false };
      } else {
        return { ...item, editable: true };
      }
    });
    setTimeout(function () {
      store.dispatch(
        Actions.GridActions.setColumns({
          stateKey: "customerSenders",
          stateful: false,
          columns: columnsSender,
        })
      );
      let _indexSender = store
        .getState()
        .dataSource.get("customerSenders")
        .get("data").size;
      store.dispatch(
        Actions.GridActions.insertRow({
          stateKey: "customerSenders",
          index: _indexSender,
          data: {
            senderId: "",
            senderCompanyName: "",
            customerCode: "",
          },
        })
      );
    }, 700);
  };

  handleReloadClick = () => {
    const { config, dispatch } = this.props;
    var me = this;
    if (config.editMode || config.isNewCustomer) {
      this.toggleModalConfirm();
      dispatch(
        configActions.setConfirmDialogHandler(function () {
          dispatch(configActions.setNewCustomerStatus(false));
          dispatch(configActions.setCustomerEditMode(false));
          window.isEditingMode = false;
          me.showLoader("Loading customers...");
          dispatch(configActions.getActiveCustomers(true, store.getState()));
          dispatch(configActions.getAllCustomers()).then(() => me.hideLoader());
          dispatch(configActions.resetSelectedConfigCustomer());
          dispatch(configActions.setFilterStr(""));
          me.toggleModalConfirm();
        })
      );
    } else {
      me.showLoader("Loading customers...");
      dispatch(configActions.getAllCustomers()).then(() => me.hideLoader());
      dispatch(configActions.resetSelectedConfigCustomer());
      dispatch(configActions.setFilterStr(""));
    }
  };

  handleDeleteLegecyId = (column, value, rowId) => {
    setTimeout(function () {
      let _list =
        store
          .getState()
          .dataSource.get("customerLegacyIds")
          .get("data")
          .toJS() || [];
      let rowIndex = _list
        .map(function (e) {
          return e._key;
        })
        .indexOf(value);
      store.dispatch(
        Actions.EditorActions.removeRow({
          stateKey: "customerLegacyIds",
          rowIndex,
        })
      );
    }, 200);
    setTimeout(function () {
      let custLegacyIds = (
        store
          .getState()
          .dataSource.get("customerLegacyIds")
          .get("data")
          .toJS() || []
      ).map((item, index) => {
        return {
          systemname: item.systemname,
          username: item.username,
          _key: item._key,
        };
      });
      custLegacyIds[custLegacyIds.length - 1]["_key"] = false;
      store.dispatch(
        Actions.GridActions.setData({
          stateKey: "customerLegacyIds",
          data: custLegacyIds,
          editMode: false,
        })
      );
    }, 700);
  };

  handleDeleteProject = (column, value, rowId) => {
    setTimeout(function () {
      let _list =
        store
          .getState()
          .dataSource.get("customerProjects")
          .get("data")
          .toJS() || [];
      let rowIndex = _list
        .map(function (e) {
          return e._key;
        })
        .indexOf(value);
      store.dispatch(
        Actions.EditorActions.removeRow({
          stateKey: "customerProjects",
          rowIndex,
        })
      );
    }, 200);

    setTimeout(function () {
      let custProjects = (
        store
          .getState()
          .dataSource.get("customerProjects")
          .get("data")
          .toJS() || []
      ).map((item, index) => {
        return {
          projectId: item.projectId,
          description: item.description,
          name: item.name,
          _key: item._key,
        };
      });
      custProjects[custProjects.length - 1]["_key"] = false;
      store.dispatch(
        Actions.GridActions.setData({
          stateKey: "customerProjects",
          data: custProjects,
          editMode: false,
        })
      );
    }, 700);
  };

  handleDeleteContact = (column, value, rowId) => {
    setTimeout(function () {
      let _list =
        store
          .getState()
          .dataSource.get("customerContacts")
          .get("data")
          .toJS() || [];
      let rowIndex = _list
        .map(function (e) {
          return e._key;
        })
        .indexOf(value);
      store.dispatch(
        Actions.EditorActions.removeRow({
          stateKey: "customerContacts",
          rowIndex,
        })
      );
    }, 200);

    setTimeout(function () {
      let custContacts = (
        store
          .getState()
          .dataSource.get("customerContacts")
          .get("data")
          .toJS() || []
      ).map((item, index) => {
        return {
          Name: item.Name,
          Email: item.Email,
          Notes: item.Notes,
          _key: item._key,
        };
      });
      custContacts[custContacts.length - 1]["_key"] = false;
      store.dispatch(
        Actions.GridActions.setData({
          stateKey: "customerContacts",
          data: custContacts,
          editMode: false,
        })
      );
    }, 700);
  };

  handleDeleteSender = (column, value, rowId) => {
    setTimeout(function () {
      let _list =
        store.getState().dataSource.get("customerSenders").get("data").toJS() ||
        [];
      let rowIndex = _list
        .map(function (e) {
          return e._key;
        })
        .indexOf(value);
      store.dispatch(
        Actions.EditorActions.removeRow({
          stateKey: "customerSenders",
          rowIndex,
        })
      );
    }, 200);

    setTimeout(function () {
      let custSenders = (
        store.getState().dataSource.get("customerSenders").get("data").toJS() ||
        []
      ).map((item, index) => {
        return {
          senderId: item.senderId,
          senderCompanyName: item.senderCompanyName,
          customerCode: item.customerCode,
          _key: item._key,
        };
      });
      custSenders[custSenders.length - 1]["_key"] = false;
      store.dispatch(
        Actions.GridActions.setData({
          stateKey: "customerSenders",
          data: custSenders,
          editMode: false,
        })
      );
    }, 700);
  };

  handleNewCustomerClick = () => {
    if (this.props.config.editMode || this.props.config.isNewCustomer) {
      this.toggleModalConfirm();
      var me = this;
      this.props.dispatch(
        configActions.setConfirmDialogHandler(function () {
          me.props.dispatch(configActions.resetConfigNewCustomer());
          me.clearAllGridsData();
          me.props.dispatch(configActions.setNewCustomerStatus(true));
          me.props.dispatch(configActions.resetSelectedConfigCustomer());
          me.props.dispatch(configActions.setFilterStr(""));
          me.applyEditMode();
          me.toggleModalConfirm();
        })
      );
    } else {
      this.props.dispatch(configActions.resetConfigNewCustomer());
      this.clearAllGridsData();
      this.props.dispatch(configActions.setNewCustomerStatus(true));
      this.props.dispatch(configActions.resetSelectedConfigCustomer());
      this.props.dispatch(configActions.setFilterStr(""));
      this.applyEditMode();
    }
  };

  handleDiscardBtnClick = () => {
    if (this.props.config.selectedCustomerInfo) {
      var me = this;
      me.props
        .dispatch(
          configActions.getProjectsByCustomerId(
            me.props.config.selectedCustomerInfo.GlobalId,
            "configView"
          )
        )
        .then((response) => {
          me.clearAllGridsData();
          me.syncGridDataSet(response)
          me.applyViewMode();
        });
    } else {
      this.applyViewMode();
    }
  };

  syncGridDataSet = response => {
    store.dispatch(
        Actions.GridActions.setData({
          stateKey: "customerLegacyIds",
          data: response.data.LegacyIds,
          editMode: true,
        })
    );
    store.dispatch(
        Actions.GridActions.setData({
          stateKey: "customerProjects",
          data: response.data.Projects,
          editMode: true,
        })
    );
    store.dispatch(
        Actions.GridActions.setData({
          stateKey: "customerSenders",
          data: response.data.Senders,
          editMode: true,
        })
    );
    store.dispatch(
        Actions.GridActions.setData({
          stateKey: "customerContacts",
          data: response.data.Contacts,
          editMode: true,
        })
    );
  }

  handleHistoryBtnClick = (e) => {
    e.preventDefault();
    const { config } = this.props;
    if (config.selectedCustomerInfo) {
      let params = {
          originalobjectid: config.selectedCustomerInfo._id,
        },
        me = this;
      axios
        .get("Configuration/history/byoriginalid", { params: params })
        .then((response) => {
          me.setState({
            modalHistory: true,
            selectedCustomerHistory: response.data.Data,
          });
        });
    }
  };

  toggleModalHistory = () => {
    this.setState({
      modalHistory: !this.state.modalHistory,
    });
  };

  handleOpenFullEventClick = (e, dataObject) => {
    if (dataObject) {
      this.setState({
        eventJsonObj: dataObject,
        fullEventModal: true,
      });
    }
  };

  toggleFullEventModal = () => {
    this.setState({
      fullEventModal: !this.state.fullEventModal,
    });
  };

  toggleModalBind = () => {
    this.setState({
      modalBind: !this.state.modalBind,
    });
  };

  handleBindBtnClick = (e) => {
    e.preventDefault();
    this.setState({
      enableBindDataDialog: false,
      bindUpdatedEventCount: 0,
      bindUpdatedDashboardVolumeCount: 0,
      bindUpdatedFilebucketCount: 0,
      bindUpdatedParkedDocumentCount: 0,
      bindUpdatedDobsCount: 0,
    });
    this.showLoader("Loading binding data...");
    this.getDataBindingStatus();
    this.toggleModalBind();
  };

  getDataBindingStatus = () => {
    const { config } = this.props;
    if (config.selectedCustomerInfo) {
      let me = this;
      axios
        .get(
          "Configuration/customers/unenrichedstats/" +
            config.selectedCustomerGlobalId
        )
        .then((response) => {
          if (me.state.showLoaderMask) {
            me.hideLoader();
          }
          let data = response.data.Data;
          me.setState({
            enableBindDataDialog:
              data.EventCount ||
              data.DashboardVolumeCount ||
              data.FilebucketCount ||
              data.ParkedDocumentCount ||
              data.DobsCount,
            bindUpdatedEventCount: data.EventCount,
            bindUpdatedDashboardVolumeCount: data.DashboardVolumeCount,
            bindUpdatedFilebucketCount: data.FilebucketCount,
            bindUpdatedParkedDocumentCount: data.ParkedDocumentCount,
            bindUpdatedDobsCount: data.DobsCount,
          });
        });
    }
  };

  handleStartDataBindingBtn = (e) => {
    e.preventDefault();
    this.updateDataBinding();
  };

  updateDataBinding = () => {
    const { config } = this.props;
    if (config.selectedCustomerInfo) {
      let params = {
          GlobalId: config.selectedCustomerGlobalId,
          CompanyName: config.selectedCustomerInfo.Name,
          Country: config.selectedCustomerInfo.Country,
        },
        me = this;
      axios
        .post("Configuration/customers/updateunenriched", params)
        .then((response) => {
          me.setState({
            modalBind: false,
          });
          me.props.dispatch(
            msgActions.success(
              "Binding updating",
              "Binding updated successfully"
            )
          );
        });
    }
  };

  handleAddUsersToUMSClick = () => {
    if (window.AddUsersToUMSLink) {
      window.open(window.AddUsersToUMSLink, "_blank");
    } else {
      this.props.dispatch(
        msgActions.error("UMS link error", "UMS link is not defined")
      );
    }
  };

  toggleActiveTab = (tab) => {
    this.props.dispatch(configActions.toggleCustomerActiveTab(tab));
  };

  handlePageClick = (event) => {
    event.preventDefault();
    const { config, dispatch } = this.props;
    var pageNum = Number(event.target.id);
    if (config.selectedCustomerInfo && pageNum > 0) {
      dispatch(configActions.setSeleCustomerConfigReportsPageNum(pageNum));
      dispatch(
        configActions.getReportsByCustomerId(
          config.selectedCustomerInfo.GlobalId,
          pageNum,
          config.selCustomerConfigReportsSize
        )
      );
    }
  };

  handlePageReload = () => {
    const { config, dispatch } = this.props;
    var pageNum = config.selCustomerConfigReportsPageNumber;
    if (config.selectedCustomerInfo && pageNum > 0) {
      dispatch(
        configActions.getReportsByCustomerId(
          config.selectedCustomerInfo.GlobalId,
          pageNum,
          config.selCustomerConfigReportsSize
        )
      );
    }
  };

  handleFirstClick = (event) => {
    event.preventDefault();
    const { config, dispatch } = this.props;
    if (config.selectedCustomerInfo) {
      dispatch(configActions.setSeleCustomerConfigReportsPageNum(1));
      dispatch(
        configActions.getReportsByCustomerId(
          config.selectedCustomerInfo.GlobalId,
          1,
          config.selCustomerConfigReportsSize
        )
      );
    }
  };

  handleAddReportBtnClick = (event) => {
    event.preventDefault();
    const { config, dispatch } = this.props;
    dispatch(reportActions.setHandleGridReloadCallBack(this.handlePageReload));
    dispatch(reportActions.setWizardSelectedReport(""));
    dispatch(reportActions.toggleModalAddReportWizard(true));
    // get customer
    dispatch(
      reportActions.setSelectedNewReportCustomer({
        GlobalId: config.selectedCustomerInfo.GlobalId,
      })
    );
  };

  getSubList = (subList, parentId, expandedCustomers) => {
    if (!expandedCustomers.includes(parentId)) return null;
    const { config } = this.props;
    return (
      subList &&
      subList.map((item, index) => {
        return (
          <li
            key={index}
            className={classnames("list-item card list sub-list", {
              selected:
                config.selectedCustomerInfo &&
                config.selectedCustomerInfo.GlobalId === item.globalId,
            })}
            onClick={(e) => this.handleSelectCustomer(item)}
            style={{ zIndex: "100" }}
          >
            <div className="customer-mug">
              <div
                className={classnames("customer-name", {
                  selected: item.filteredProp === "globalId",
                })}
              >
                ID: {item.globalId}
              </div>
              <div
                className={classnames("customer-name", {
                  selected: item.filteredProp === "name",
                })}
              >
                Name: {item.name}
              </div>
              {item.filteredProp === "sapId" && (
                <div
                  className={classnames("customer-name", {
                    selected: item.filteredProp === "sapId",
                  })}
                >
                  SAPId: {item.sapid}
                </div>
              )}
              {item.foundLegacyIdUserName && (
                <div className="customer-name selected">
                  Legacy ID: {item.foundLegacyIdUserName}
                </div>
              )}
              {item.foundProjectId && (
                <div className="customer-name selected">
                  Project: {item.foundProjectId}
                </div>
              )}
              {item.foundSenderId && (
                <div className="customer-name selected">
                  Sender Id: {item.foundSenderId}
                </div>
              )}
            </div>
            {item.act && (
              <div className="customer-state active-state">
                <span className="fa fa-check-circle" />
                <span className="customer-serial">Active</span>
              </div>
            )}
            {!item.act && (
              <div className="customer-state inactive-state">
                <span className="fa fa-ban" />
                <span className="customer-serial">Inactive</span>
              </div>
            )}
            <div className="clearfix" />
          </li>
        );
      })
    );
  };

  isCustomerExpanded = (id) => this.props.config.expandedCustomers.includes(id);

  handleToggleExpandCustomer = (e, id) => {
    if (e) e.stopPropagation();
    this.props.dispatch(configActions.toggleExpandCustomer(id));
  };

  generateChildCustomerGrid = (childList) => {
    if (childList.length === 0) {
      return (
        <div className="empty-text">
          <p>No child customers for selected customer</p>
        </div>
      );
    }
    var table_html = [];
    childList.forEach((customer, index) => {
      table_html.push(
        <tr key={index} className="row_tr finger">
          <td className="text-center">{customer.globalId}</td>
          <td className="text-center">{customer.name}</td>
          <td className="text-center">{customer.country}</td>
          <td className="text-center">{customer.sncid}</td>
        </tr>
      );
    });

    return (
      <div className="col-12" style={{ padding: "0px" }}>
        <div className="row" style={{ margin: "0px" }}>
          <table
            className="table-bordered table-condensed cf table-hover table-sm panel-default col-12 col-lg-offset-0"
            cellSpacing="0"
            style={{ border: "0px", padding: "0px" }}
          >
            <thead
              style={{ background: "#3A4A57", color: "#fff" }}
              className="grids_header"
            >
              <tr style={{ fontSize: ".8rem" }}>
                <th className="text-center">Global ID</th>
                <th className="text-center">Name</th>
                <th className="text-center">Country</th>
                <th className="text-center">ServiceNow ID</th>
              </tr>
            </thead>
            <tbody style={{ backgroundColor: "#fff", fontSize: "12px" }}>
              {table_html}
            </tbody>
          </table>
        </div>
      </div>
    );
  };

  componentDidMount = () => {
    const { config, dispatch } = this.props;
    let me = this;
    if (
      !config.loading_all_customer &&
      (!config.allCustomers || config.allCustomers.length === 0)
    ) {
      dispatch(configActions.getAllCustomers());
    }
    setTimeout(function () {
      const { config } = me.props;
      if (config.editMode || config.isNewCustomer) {
        me.applyEditMode();
      }
    }, 400);

    this.unlisten = this.props.history.listen((location, action) => {
      const { config } = this.props;
      if (location.pathname !== "/customers") {
        if (config.editMode || config.isNewCustomer) {
          dispatch(configActions.toggleModalConfirm(true));
          dispatch(
            configActions.setConfirmDialogHandler(function () {
              dispatch(configActions.toggleModalConfirm(false));
              me.applyViewMode();
              setTimeout(function () {
                me.props.history.push(location.pathname);
              }, 200);
            })
          );
          me.props.history.push("/customers");
        }
      }
    });

    window.addEventListener("hashchange", this.handleHashChange, {
      once: true,
    });
  };

  componentWillUnmount = () => {
    this.unlisten();
  };

  render() {
    const { config, userLDAPUserRights, translate } = this.props;
    let customerOptions = [];
    (config.allCustomers || []).forEach((item) => {
      if (
        config.selectedCustomerInfo &&
        config.selectedCustomerInfo.GlobalId !== item.globalId
      ) {
        customerOptions.push({ value: item.oId, label: item.name });
      }
    });

    let PageNumber = config.selCustomerConfigReportsPageNumber;
    let prev = PageNumber > 0 ? PageNumber - 1 : 0;
    let pageNumbers = [];
    // get window of max 5
    let start = PageNumber;
    let last = start + 5;
    // here we will deal with this variable as a real total pages
    if (last > config.selCustomerConfigReportsTotalPages) {
      last = config.selCustomerConfigReportsTotalPages;
    }
    for (let i = start; i <= last; i++) {
      pageNumbers.push(i);
    }

    let filteredCustomer = [];
    var _expandedCustomers = config.expandedCustomers.slice(0);
    if (config.allCustomers) {
      if (config.filterStr) {
        const regex = new RegExp(config.filterStr, "i");
        (config.allCustomers || []).forEach(function (obj) {
          if (
            obj.name.match(regex) ||
            obj.globalId.match(regex) ||
            (obj.sapid && obj.sapid.match(regex))
          ) {
            filteredCustomer.push(
              Object.assign({}, obj, {
                filteredProp: obj.globalId.match(regex)
                  ? "globalId"
                  : obj.name.match(regex)
                  ? "name"
                  : "sapId",
              })
            );
          } else {
            let foundLegacyIdUserName = null;
            let foundProjectId = null;
            let foundSenderId = null;
            var i = 0;
            if (obj.legacyids && obj.legacyids.length) {
              for (i = 0; i < obj.legacyids.length; i++) {
                if (obj.legacyids[i].username.match(regex)) {
                  foundLegacyIdUserName = obj.legacyids[i].username;
                  break;
                }
              }
            }
            if (obj.projects && obj.projects.length) {
              for (i = 0; i < obj.projects.length; i++) {
                if (obj.projects[i].projectId.match(regex)) {
                  foundProjectId = obj.projects[i].projectId;
                  break;
                }
              }
            }
            if (obj.senders && obj.senders.length) {
              for (i = 0; i < obj.senders.length; i++) {
                if (obj.senders[i].senderId.match(regex)) {
                  foundSenderId = obj.senders[i].senderId;
                  break;
                }
              }
            }
            if (foundLegacyIdUserName) {
              filteredCustomer.push(
                Object.assign({}, obj, {
                  foundLegacyIdUserName: foundLegacyIdUserName,
                })
              );
            } else if (foundProjectId) {
              filteredCustomer.push(
                Object.assign({}, obj, {
                  foundProjectId: foundProjectId,
                })
              );
            } else if (foundSenderId) {
              filteredCustomer.push(
                Object.assign({}, obj, {
                  foundSenderId: foundSenderId,
                })
              );
            }
          }
          if (obj.childList && obj.childList.length) {
            var _childList = [];
            obj.childList.forEach(function (subObj) {
              if (
                subObj.name.match(regex) ||
                subObj.globalId.match(regex) ||
                (subObj.sapid && subObj.sapid.match(regex))
              ) {
                // add parent once if not exist
                if (!filteredCustomer.find((x) => x.oId === obj.oId)) {
                  filteredCustomer.push({ ...obj });
                  !_expandedCustomers.includes(obj.oId) &&
                    _expandedCustomers.push(obj.oId);
                }
                _childList.push(
                  Object.assign({}, subObj, {
                    filteredProp: subObj.globalId.match(regex)
                      ? "globalId"
                      : subObj.name.match(regex)
                      ? "name"
                      : "sapId",
                  })
                );
              } else {
                let foundLegacyIdUserName = null;
                let foundProjectId = null;
                let foundSenderId = null;
                var i = 0;
                if (subObj.legacyids && subObj.legacyids.length) {
                  for (i = 0; i < subObj.legacyids.length; i++) {
                    if (subObj.legacyids[i].username.match(regex)) {
                      foundLegacyIdUserName = subObj.legacyids[i].username;
                      break;
                    }
                  }
                }
                if (subObj.projects && subObj.projects.length) {
                  for (i = 0; i < subObj.projects.length; i++) {
                    if (subObj.projects[i].projectId.match(regex)) {
                      foundProjectId = subObj.projects[i].projectId;
                      break;
                    }
                  }
                }
                if (subObj.senders && subObj.senders.length) {
                  for (i = 0; i < subObj.senders.length; i++) {
                    if (subObj.senders[i].senderId.match(regex)) {
                      foundSenderId = subObj.senders[i].senderId;
                      break;
                    }
                  }
                }
                if (foundLegacyIdUserName) {
                  if (!filteredCustomer.find((x) => x.oId === obj.oId)) {
                    filteredCustomer.push({ ...obj });
                    !_expandedCustomers.includes(obj.oId) &&
                      _expandedCustomers.push(obj.oId);
                  }
                  _childList.push(
                    Object.assign({}, subObj, {
                      foundLegacyIdUserName: foundLegacyIdUserName,
                    })
                  );
                } else if (foundProjectId) {
                  if (!filteredCustomer.find((x) => x.oId === obj.oId)) {
                    filteredCustomer.push({ ...obj });
                    !_expandedCustomers.includes(obj.oId) &&
                      _expandedCustomers.push(obj.oId);
                  }
                  _childList.push(
                    Object.assign({}, subObj, {
                      foundProjectId: foundProjectId,
                    })
                  );
                } else if (foundSenderId) {
                  if (!filteredCustomer.find((x) => x.oId === obj.oId)) {
                    filteredCustomer.push({ ...obj });
                    !_expandedCustomers.includes(obj.oId) &&
                      _expandedCustomers.push(obj.oId);
                  }
                  _childList.push(
                    Object.assign({}, subObj, {
                      foundSenderId: foundSenderId,
                    })
                  );
                }
              }
            });
            var _objIndex = filteredCustomer.findIndex(
              (x) => x.oId === obj.oId
            );
            if (_objIndex > -1) {
              filteredCustomer[_objIndex].childList = _childList;
            }
          }
        });
      } else {
        filteredCustomer = config.allCustomers;
      }
    }
    let legacyIdsData = [],
      projectsData = [],
      contactsData = [],
      sendersData = [];
    if (config.selectedCustomerInfo) {
      legacyIdsData = _.uniq(config.selectedCustomerInfo.LegacyIds || []);
      projectsData = _.uniq(config.selectedCustomerInfo.Projects || []);
      contactsData = _.uniq(config.selectedCustomerInfo.Contacts || []);
      sendersData = _.uniq(config.selectedCustomerInfo.Senders || []);
    }

    const _plugins = {
      COLUMN_MANAGER: {
        resizable: true,
        moveable: true,
        sortable: {
          enabled: false,
          method: "local",
        },
      },
      EDITOR: {
        enabled: true,
        type: "grid",
      },

      LOADER: {
        enabled: true,
      },

      ERROR_HANDLER: {
        defaultErrorMessage: "AN ERROR OCURRED",
        enabled: true,
      },
    };
    const _pluginsLegacyIds = {
      ..._plugins,
    };
    const _pluginsProjects = {
      ..._plugins,
    };

    const _pluginsContacts = {
      ..._plugins,
    };
    const _pluginsSenders = {
      ..._plugins,
    };

    return (
      <div id="config-main" className="row">
        {this.state.showLoaderMask && (
          <div className="opus_loader">
            <div className="lds-spinner">
              <div />
              <div />
              <div />
              <div />
              <div />
              <div />
              <div />
              <div />
              <div />
              <div />
              <div />
              <div />
            </div>
            <div className="lds-text">{this.state.loaderMaskText}</div>
          </div>
        )}
        <div className="main-container">
          <div className="Pane vertical Pane1 config-view-left">
            <div className="w-100">
              <div className="d-flex flex-row" style={{ flex: "1 1 0%" }}>
                <button
                  type="button"
                  onClick={this.handleNewCustomerClick}
                  className="btn btn-secondary btn-posti-default"
                >
                  <span className="fa fa-plus" />
                </button>
                <div
                  className="d-flex flex-row"
                  style={{ width: "100%", margin: "0 5px" }}
                >
                  <div className="input-group min-top-input-borders-set config-filter">
                    <span
                      className="fa fa-search search-config-icon"
                      aria-hidden="true"
                    />
                    <input
                      type="text"
                      placeholder="Search by Name, ID, Project, Legacy ID"
                      className="form-control"
                      value={config.filterStr}
                      onChange={this.onSearchTextFieldChange.bind(this)}
                      style={{ border: "0px", paddingLeft: "0.3rem" }}
                    />
                  </div>
                </div>
                <button
                  type="button"
                  className="btn btn-secondary w_action btn-posti-default"
                  onClick={this.handleReloadClick}
                >
                  <span className="fa fa-retweet" />
                </button>
              </div>
            </div>
            <div
              className={`w-100 d-inline-block h-100 customer-list-container ${
                config.loading_all_customer ? "loading" : ""
              }`}
            >
              <ul>
                <div style={{ position: "relative" }}>
                  {config.loading_all_customer && (
                    <div className="list-loading-container">
                      <div className="loading-list" />
                      <div>Loading</div>
                    </div>
                  )}
                  {filteredCustomer &&
                    filteredCustomer.map((item, index) => {
                      return [
                        <li
                          key={index}
                          className={classnames("list-item card list", {
                            selected: config.selectedCustomerInfo?.GlobalId === item.globalId
                          })}
                          onClick={(e) => this.handleSelectCustomer(item)}
                          style={{ zIndex: "100" }}
                        >
                          {item.childList && item.childList.length > 0 && (
                            <span
                              data-role="expander"
                              data-mode="close"
                              className="icons-expander"
                              onClick={(e) =>
                                this.handleToggleExpandCustomer(e, item.oId)
                              }
                            >
                              {_expandedCustomers.includes(item.oId) ? (
                                <i
                                  className="fa fa-angle-down"
                                  style={{
                                    marginLeft: "-1px",
                                    marginRight: "-1px",
                                  }}
                                />
                              ) : (
                                <i className="fa fa-angle-right" />
                              )}
                            </span>
                          )}
                          <div
                            className="customer-mug"
                            style={
                              item.childList && item.childList.length > 0
                                ? { width: "224px" }
                                : {}
                            }
                          >
                            <div
                              className={classnames("customer-name", {
                                selected: item.filteredProp === "globalId",
                              })}
                            >
                              ID: {item.globalId}
                            </div>
                            <div
                              className={classnames("customer-name", {
                                selected: item.filteredProp === "name",
                              })}
                            >
                              Name: {item.name}
                            </div>
                            {item.filteredProp === "sapId" && (
                              <div
                                className={classnames("customer-name", {
                                  selected: item.filteredProp === "sapId",
                                })}
                              >
                                SAPId: {item.sapid}
                              </div>
                            )}
                            {item.foundLegacyIdUserName && (
                              <div className="customer-name selected">
                                Legacy ID: {item.foundLegacyIdUserName}
                              </div>
                            )}
                            {item.foundProjectId && (
                              <div className="customer-name selected">
                                Project: {item.foundProjectId}
                              </div>
                            )}
                            {item.foundSenderId && (
                              <div className="customer-name selected">
                                Sender Id: {item.foundSenderId}
                              </div>
                            )}
                          </div>
                          {item.act && (
                            <div className="customer-state active-state">
                              <span className="fa fa-check-circle" />
                              <span className="customer-serial">Active</span>
                            </div>
                          )}
                          {!item.act && (
                            <div className="customer-state inactive-state">
                              <span className="fa fa-ban" />
                              <span className="customer-serial">Inactive</span>
                            </div>
                          )}
                          <div className="clearfix" />
                        </li>,
                        this.getSubList(
                          item.childList,
                          item.oId,
                          _expandedCustomers
                        ),
                      ];
                    })}
                </div>
              </ul>
            </div>
            <div className="customer-list-footer">
              Customer displayed: {filteredCustomer.length}{" "}
            </div>
          </div>
          <div className="config-view-main">
            {(config.selectedCustomerInfo || config.isNewCustomer) && (
              <div>
                <div className="w-100 d-flex justify-content-between customer-details-header">
                  <div className="active-checkbox-container">
                    {!config.isNewCustomer && (
                      <div style={{ float: "left" }}>
                        <div style={{ float: "left", padding: "5px 0" }}>
                          <input
                            type="checkbox"
                            name="act"
                            checked={
                              config.selectedCustomerInfo &&
                              config.selectedCustomerInfo.act
                            }
                            style={{ margin: "10px 0px 0 -21px" }}
                            className="form-check-input"
                            onChange={this.updateSeleCusState}
                          />
                          <label
                            htmlFor="Is_Active"
                            style={{ marginTop: "3px" }}
                            className="form-check-label"
                          >
                            Active
                          </label>
                        </div>
                        <button
                          type="button"
                          className="tooltip-btn"
                          data-tip
                          data-place="bottom"
                          data-type="info"
                          data-effect="solid"
                          data-for="config-activationTip"
                        >
                          <i
                            className="fa fa-question-circle"
                            style={{ padding: "12px 10px 8px" }}
                          />
                        </button>
                        <ReactTooltip
                          className="customeTheme"
                          id="config-activationTip"
                        >
                          <div>
                            <strong>Status of company</strong>
                            <p>
                              If company is inactive, then it doesn't appear in
                              selection of companies in Files/Documents views.
                              <br />
                              Status of company is saved as soon as checkbox is
                              checked or unchecked.
                              <br />
                              No save is needed
                            </p>
                          </div>
                        </ReactTooltip>
                      </div>
                    )}
                    <Button
                      color="primary"
                      className="EventSearchSubmit"
                      style={{ width: "140px", marginLeft: "15px" }}
                      disabled={
                        !(
                          config.selectedCustomerInfo &&
                          config.selectedCustomerInfo.act
                        ) && !config.isNewCustomer
                      }
                      onClick={this.handleSaveCustomer}
                    >
                      <span>
                        {config.editMode || config.isNewCustomer
                          ? "Save"
                          : "Edit"}
                      </span>
                    </Button>
                    {(config.editMode || config.isNewCustomer) && (
                      <button
                        type="button"
                        className="btn btn-secondary"
                        style={{ width: "140px", marginLeft: "75px" }}
                        onClick={this.handleDiscardBtnClick}
                      >
                        Discard
                      </button>
                    )}
                    {config.isNewCustomer && (
                      <div className="adding-customer-text">
                        Please enter the required fields and press "Save"
                        button.
                      </div>
                    )}
                  </div>
                  {!config.isNewCustomer && (
                    <div>
                      <Button
                        color="primary"
                        className="EventSearchSubmit"
                        onClick={this.handleAddUsersToUMSClick}
                        style={{ verticalAlign: "top", marginRight: "20px" }}
                      >
                        Add users to UMS
                      </Button>
                      {!config.editMode && (
                        <span>
                          <Button
                            color="primary"
                            className="EventSearchSubmit"
                            disabled={!legacyIdsData.length}
                            onClick={this.handleBindBtnClick}
                            style={{ width: "140px", verticalAlign: "top" }}
                          >
                            Bind
                          </Button>
                          <button
                            type="button"
                            className="tooltip-btn"
                            data-tip
                            data-place="bottom"
                            data-type="info"
                            data-effect="solid"
                            data-for="config-bindTip"
                          >
                            <i
                              className="fa fa-question-circle"
                              style={{ padding: "12px 10px 8px" }}
                            />
                          </button>
                          <ReactTooltip
                            className="customeTheme"
                            id="config-bindTip"
                          >
                            <div>
                              <strong>Bind data (enrich)</strong>
                              <p>
                                Allows to associate (bind) files/documents of
                                current customer if its not done before.
                                <br />
                                It could be, that data of newly created
                                customer, was sent to NTT before creation of
                                customer.
                                <br />
                                It won't be possible to find these
                                documents/files without associating data with
                                this customer.
                                <br />
                                Button allows to check existence of such data
                                and associate if needed.
                              </p>
                            </div>
                          </ReactTooltip>
                        </span>
                      )}
                    </div>
                  )}
                </div>
                <div className="row config-content-form">
                  <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 nav-customer-container">
                    <Nav tabs>
                      <NavItem>
                        <NavLink
                          className={classnames({
                            active: config.activeTab === "1",
                          })}
                          style={{ position: "relative" }}
                          onClick={() => {
                            this.toggleActiveTab("1");
                            if (config.editMode || config.isNewCustomer) {
                              this.handleFirstTabGridsEdit();
                            }
                          }}
                        >
                          General Information
                          {!!this.state.generalInfoErrorNum &&
                            this.state.generalInfoErrorNum > 0 && (
                              <span className="tab-error-label">
                                {this.state.generalInfoErrorNum}
                              </span>
                            )}
                        </NavLink>
                      </NavItem>
                      <NavItem>
                        <NavLink
                          className={classnames({
                            active: config.activeTab === "2",
                          })}
                          onClick={() => {
                            this.toggleActiveTab("2");
                          }}
                        >
                          Reports{" "}
                          {`[${
                            (config.selCustomerConfiguredReports &&
                              config.selCustomerConfiguredReports.length) ||
                            0
                          }]`}
                        </NavLink>
                      </NavItem>
                      <NavItem>
                        <NavLink
                          className={classnames({
                            active: config.activeTab === "3",
                          })}
                          style={{ position: "relative" }}
                          onClick={() => {
                            this.toggleActiveTab("3");
                            if (config.editMode || config.isNewCustomer) {
                              this.handleThirdTabGridsEdit();
                            }
                          }}
                        >
                          Senders{" "}
                          {`[${(sendersData && sendersData.length) || 0}]`}
                          {!!this.state.sendersErrorNum &&
                            this.state.sendersErrorNum > 0 && (
                              <span className="tab-error-label">
                                {this.state.sendersErrorNum}
                              </span>
                            )}
                        </NavLink>
                      </NavItem>
                      {config.selectedCustomerInfo &&
                        config.selectedCustomerInfo.childrenIds &&
                        config.selectedCustomerInfo.childrenIds.length > 0 && (
                          <NavItem>
                            <NavLink
                              className={classnames({
                                active: config.activeTab === "4",
                              })}
                              onClick={() => {
                                this.toggleActiveTab("4");
                              }}
                            >
                              Child companies{" "}
                              {`[${
                                (config.selectedCustomerChildList &&
                                  config.selectedCustomerChildList.length) ||
                                0
                              }]`}
                            </NavLink>
                          </NavItem>
                        )}
                    </Nav>
                    <TabContent activeTab={config.activeTab}>
                      <TabPane tabId="1">
                        <Form
                          ref={(c) => {
                            this.form = c;
                          }}
                        >
                          <div className="config-details-left row">
                            <div className="col col-xl-6 col-lg-12">
                              <div style={{ margin: "25px 10px 10px" }}>
                                <strong>General information</strong>
                              </div>
                              <div className="form-group">
                                <label className="cols-sm-2 control-label">
                                  Global ID *
                                </label>
                                <Input
                                  readOnly={
                                    !config.editMode && !config.isNewCustomer
                                  }
                                  type="text"
                                  validations={[required, lt]}
                                  maxLength={10}
                                  ref={(c) => {
                                    this.globalIdInput = c;
                                  }}
                                  name="GlobalId"
                                  value={
                                    config.selectedCustomerInfo
                                      ? config.selectedCustomerGlobalId
                                      : config.isNewCustomer &&
                                        config.newCustomerData.GlobalId
                                  }
                                  onChange={this.updateSeleCusState}
                                />
                                <button
                                  type="button"
                                  className="tooltip-btn"
                                  data-tip
                                  data-place="right"
                                  data-type="info"
                                  data-effect="solid"
                                  data-for="config-globalIdTip"
                                >
                                  <i
                                    className="fa fa-question-circle"
                                    style={{ padding: "12px 10px 8px" }}
                                  />
                                </button>
                                <ReactTooltip
                                  className="customeTheme"
                                  id="config-globalIdTip"
                                >
                                  <div>
                                    <strong>Global ID of company in NTT</strong>
                                    <p>
                                      It's recommended to set this id to SAP Id
                                      of particular company.
                                      <br />
                                      This ID also should be in sync with
                                      company ID in UMS, if customer will have
                                      users that will login to NTT Portal.
                                    </p>
                                  </div>
                                </ReactTooltip>
                              </div>
                              <div className="form-group">
                                <label className="cols-sm-2 control-label">
                                  Company name *
                                </label>
                                <Input
                                  type="text"
                                  validations={[required, lt]}
                                  maxLength={60}
                                  ref={(c) => {
                                    this.companyNameInput = c;
                                  }}
                                  readOnly={
                                    !config.editMode && !config.isNewCustomer
                                  }
                                  name="Name"
                                  value={
                                    config.selectedCustomerInfo
                                      ? config.selectedCustomerName
                                      : config.isNewCustomer &&
                                        config.newCustomerData.Name
                                  }
                                  onChange={this.updateSeleCusState}
                                />
                              </div>
                              <div className="form-group">
                                <label className="cols-sm-2 control-label">
                                  SAP ID
                                </label>
                                <Input
                                  type="text"
                                  readOnly={
                                    !config.editMode && !config.isNewCustomer
                                  }
                                  name="sapId"
                                  value={
                                    config.selectedCustomerInfo
                                      ? config.selectedCustomerInfo.sapId || ""
                                      : config.isNewCustomer &&
                                        (config.newCustomerData.sapId || "")
                                  }
                                  onChange={this.updateSeleCusState}
                                />
                              </div>
                              {config.selectedCustomerInfo &&
                              config.selectedCustomerInfo.childrenIds &&
                              config.selectedCustomerInfo.childrenIds.length >
                                0 ? null : (
                                <div className="form-group">
                                  <label className="cols-sm-2 control-label">
                                    Parent company
                                  </label>
                                  <Select
                                    name="parentId"
                                    value={
                                      config.selectedCustomerInfo
                                        ? config.selectedCustomerInfo.parentId
                                        : config.isNewCustomer &&
                                          config.newCustomerData.parentId
                                    }
                                    placeholder="Select parent company..."
                                    disabled={
                                      (!config.editMode &&
                                        !config.isNewCustomer) ||
                                      !(
                                        userLDAPUserRights &&
                                        userLDAPUserRights.IsNTTAdmin
                                      )
                                    }
                                    style={{ borderColor: "#a9a9a9" }}
                                    onChange={this.updateSeleCusParentId}
                                    options={customerOptions}
                                  />
                                  <button
                                    type="button"
                                    className="tooltip-btn"
                                    data-tip
                                    data-place="right"
                                    data-effect="solid"
                                    data-for="config-parentIdTip"
                                  >
                                    <i
                                      className="fa fa-question-circle"
                                      style={{ padding: "12px 10px 8px" }}
                                    />
                                  </button>
                                  <ReactTooltip
                                    className="customeTheme"
                                    id="config-parentIdTip"
                                  >
                                    <strong>Global ID of company in NTT</strong>
                                    <p>
                                      If you set Parent organization in this
                                      field, then selected parent organization’s
                                      TNT Portal users will be able to see also
                                      data (docs, files) of currently editable
                                      company.
                                      <br />
                                      Be carefull with this. Only users with
                                      netti domain role SG_ROLE_TNT_ADMIN can
                                      change this value. Ask TNT team or
                                      administrators to add this role if
                                      required.
                                    </p>
                                  </ReactTooltip>
                                </div>
                              )}
                              <div className="form-group">
                                <label className="cols-sm-2 control-label">
                                  ServiceNow ID *
                                </label>
                                <Input
                                  type="text"
                                  validations={[required, lt]}
                                  maxLength={20}
                                  readOnly={
                                    !config.editMode && !config.isNewCustomer
                                  }
                                  name="SNCId"
                                  value={
                                    config.selectedCustomerInfo
                                      ? config.selectedCustomerInfo.SNCId
                                      : config.isNewCustomer &&
                                        config.newCustomerData.SNCId
                                  }
                                  onChange={this.updateSeleCusState}
                                />
                                <button
                                  type="button"
                                  className="tooltip-btn"
                                  data-tip
                                  data-place="right"
                                  data-effect="solid"
                                  data-for="config-SNCIdTip"
                                >
                                  <i
                                    className="fa fa-question-circle"
                                    style={{ padding: "12px 10px 8px" }}
                                  />
                                </button>
                                <ReactTooltip
                                  className="customeTheme"
                                  id="config-SNCIdTip"
                                >
                                  <p>
                                    ServiceNow ID will be used for automatic
                                    ticket creation, in case if some errors
                                    during file/documents processing will be
                                    reported, or SLA times exceeded
                                  </p>
                                </ReactTooltip>
                              </div>
                              <div
                                className="form-group"
                                style={{ height: "54px" }}
                              >
                                <label className="cols-sm-2 control-label">
                                  Country *
                                </label>
                                <Select
                                  name="Country"
                                  value={
                                    config.selectedCustomerInfo
                                      ? config.selectedCustomerInfo.Country
                                      : config.isNewCustomer &&
                                        config.newCustomerData.Country
                                  }
                                  disabled={
                                    !config.editMode && !config.isNewCustomer
                                  }
                                  placeholder="Select country..."
                                  onChange={this.updateSeleCusCountryState}
                                  style={{ borderColor: "#a9a9a9" }}
                                  options={[
                                    { value: "Finland", label: "Finland" },
                                    { value: "Norway", label: "Norway" },
                                    { value: "Sweden", label: "Sweden" },
                                  ]}
                                  required
                                />
                              </div>
                              {!this.state.validCountry && (
                                <div
                                  style={{
                                    marginLeft: "160px",
                                    marginTop: "-17px",
                                    marginBottom: "9px",
                                  }}
                                  className="validation-error"
                                >
                                  Required
                                </div>
                              )}
                              <div
                                className="form-group"
                                style={{ height: "54px", margin: "0" }}
                              >
                                <label className="cols-sm-2 control-label">
                                  Language *
                                </label>
                                <Select
                                  name="Language"
                                  placeholder="Select ..."
                                  disabled={
                                    !config.editMode && !config.isNewCustomer
                                  }
                                  onChange={this.updateSeleCusLangState}
                                  style={{ borderColor: "#a9a9a9" }}
                                  value={
                                    config.selectedCustomerInfo
                                      ? config.selectedCustomerInfo.Language
                                      : config.isNewCustomer &&
                                        config.newCustomerData.Language
                                  }
                                  options={[
                                    { value: "FIN", label: "FIN" },
                                    { value: "NOR", label: "NOR" },
                                    { value: "SWE", label: "SWE" },
                                    { value: "ENG", label: "ENG" },
                                  ]}
                                  required
                                />
                              </div>
                              {!this.state.validLanguage && (
                                <div
                                  style={{
                                    marginLeft: "160px",
                                    marginTop: "-17px",
                                  }}
                                  className="validation-error"
                                >
                                  Required
                                </div>
                              )}
                            </div>
                            <div className="col col-xl-6 col-lg-12">
                              <div style={{ margin: "25px 10px 10px" }}>
                                <strong>Legacy IDs</strong>
                                <button
                                  type="button"
                                  className="tooltip-btn"
                                  data-tip
                                  data-place="bottom"
                                  data-type="info"
                                  data-effect="solid"
                                  data-for="config-LegacyIDsTip"
                                >
                                  <i
                                    className="fa fa-question-circle"
                                    style={{ padding: "0 10px" }}
                                  />
                                </button>
                                <ReactTooltip
                                  className="customeTheme"
                                  id="config-LegacyIDsTip"
                                >
                                  <div>
                                    <p>
                                      Pairs of platform-ids that are used to
                                      identify files/documents belonging to
                                      particular company.
                                      <br />
                                      Username is platform specific - for MCI it
                                      is es3user, for minivan its ID defined in
                                      MIP config.
                                      <br />
                                      This data is used for associating
                                      (binding) particular files/documents to
                                      customer.
                                    </p>
                                  </div>
                                </ReactTooltip>
                              </div>
                              {config.activeTab === "1" && (
                                <Grid
                                  columns={legacyIdsColumns}
                                  ref={(c) => {
                                    this.legacyIdsGrid = c;
                                  }}
                                  data={legacyIdsData}
                                  store={store}
                                  height="250px"
                                  stateKey="customerLegacyIds"
                                  plugins={_pluginsLegacyIds}
                                />
                              )}
                              <ul style={{ margin: "10px 0 0 0" }}>
                                {this.state.showLegacyIdsListError &&
                                  Object.keys(this.state.legacyIdsErrors).map(
                                    (keyName, keyIndex) => {
                                      return (
                                        <li
                                          key={keyIndex}
                                          className="validation-error"
                                        >
                                          {this.state.legacyIdsErrors[keyName]}
                                        </li>
                                      );
                                    }
                                  )}
                              </ul>
                            </div>
                          </div>
                          <div className="config-details-right">
                            <div style={{ margin: "25px 10px 10px" }}>
                              <strong>Flows</strong>
                              <button
                                type="button"
                                className="tooltip-btn"
                                data-tip
                                data-place="bottom"
                                data-type="info"
                                data-effect="solid"
                                data-for="config-ProjectsTip"
                              >
                                <i
                                  className="fa fa-question-circle"
                                  style={{ padding: "0 10px" }}
                                />
                              </button>
                              <ReactTooltip
                                className="customeTheme"
                                id="config-ProjectsTip"
                              >
                                <div>
                                  <p>
                                    Flows are used for project filter in
                                    files/documents view.
                                  </p>
                                </div>
                              </ReactTooltip>
                            </div>
                            {config.activeTab === "1" && (
                              <Grid
                                columns={projectsColumns}
                                ref={(c) => {
                                  this.projectsGrid = c;
                                }}
                                data={projectsData}
                                store={store}
                                height="320px"
                                stateKey="customerProjects"
                                plugins={_pluginsProjects}
                              />
                            )}
                            <ul style={{ margin: "10px 0 0 0" }}>
                              {this.state.showProjectsListError &&
                                Object.keys(this.state.projectsErrors).map(
                                  (keyName, keyIndex) => {
                                    return (
                                      <li
                                        key={keyIndex}
                                        className="validation-error"
                                      >
                                        {this.state.projectsErrors[keyName]}
                                      </li>
                                    );
                                  }
                                )}
                            </ul>
                            <div style={{ margin: "25px 10px 10px" }}>
                              <strong>
                                Contact persons (used only for information)
                              </strong>
                            </div>
                            {config.activeTab === "1" && (
                              <Grid
                                columns={contactsColumns}
                                ref={(c) => {
                                  this.contactsGrid = c;
                                }}
                                data={contactsData}
                                store={store}
                                height="185px"
                                stateKey="customerContacts"
                                plugins={_pluginsContacts}
                              />
                            )}
                            <ul style={{ margin: "10px 0 0 0" }}>
                              {this.state.showContactsListError &&
                                Object.keys(this.state.contactsErrors).map(
                                  (keyName, keyIndex) => {
                                    return (
                                      <li
                                        key={keyIndex}
                                        className="validation-error"
                                      >
                                        {this.state.contactsErrors[keyName]}
                                      </li>
                                    );
                                  }
                                )}
                            </ul>
                            {!config.isNewCustomer && (
                              <div style={{ padding: "50px 0 50px 300px" }}>
                                <div>
                                  <span>
                                    <strong>Last changed by: </strong>
                                  </span>
                                  <span>
                                    {config.selectedCustomerInfo &&
                                      config.selectedCustomerInfo.LastUpdatedBy}
                                  </span>
                                </div>
                                <div>
                                  <span>
                                    <strong>Last changed date: </strong>
                                  </span>
                                  <span>
                                    {config.selectedCustomerInfo &&
                                    config.selectedCustomerInfo.LastUpdated
                                      ? moment
                                          .utc(
                                            config.selectedCustomerInfo
                                              .LastUpdated,
                                            moment.ISO_8601
                                          )
                                          .format("DD.MM.YYYY")
                                      : "n/a"}
                                  </span>
                                </div>
                                <Button
                                  color="primary"
                                  className="EventSearchSubmit"
                                  style={{ marginTop: "5px" }}
                                  onClick={this.handleHistoryBtnClick}
                                >
                                  History
                                </Button>
                              </div>
                            )}
                          </div>
                        </Form>
                      </TabPane>
                      <TabPane tabId="2">
                        <div
                          className="w-100 d-flex justify-content-between"
                          style={{ padding: "10px 30px" }}
                        >
                          <Button
                            color="primary"
                            disabled={
                              !(
                                config.selectedCustomerInfo &&
                                config.selectedCustomerInfo.act
                              )
                            }
                            className="EventSearchSubmit"
                            onClick={this.handleAddReportBtnClick}
                            style={{ verticalAlign: "top" }}
                          >
                            {translate("AddReport")}
                          </Button>
                        </div>
                        <ConfigReportsGrid
                          reports={config.selCustomerConfiguredReports}
                          reportName="customerConfiguredReports"
                          handlePageReload={this.handlePageReload}
                          handlePageClick={this.handlePageClick}
                          handleFirstClick={this.handleFirstClick}
                          PageNumber={PageNumber}
                          prev={prev}
                          last={last}
                          pageNumbers={pageNumbers}
                          showCustomerColumn={false}
                        />
                      </TabPane>
                      <TabPane tabId="3">
                        {config.activeTab === "3" && (
                          <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                            <div style={{ margin: "25px 10px 10px" }}>
                              <strong>Senders</strong>
                              <button
                                type="button"
                                className="tooltip-btn"
                                data-tip
                                data-place="bottom"
                                data-type="info"
                                data-effect="solid"
                                data-for="config-SendersTip"
                              >
                                <i
                                  className="fa fa-question-circle"
                                  style={{ padding: "0 10px" }}
                                />
                              </button>
                              <ReactTooltip
                                className="customeTheme"
                                id="config-SendersTip"
                              >
                                <div>
                                  <p>
                                    Senders are used for sender filter in
                                    files/documents view.
                                  </p>
                                </div>
                              </ReactTooltip>
                            </div>
                            <Grid
                              columns={sendersColumns}
                              ref={(c) => {
                                this.sendersGrid = c;
                              }}
                              data={sendersData}
                              store={store}
                              height="320px"
                              stateKey="customerSenders"
                              plugins={_pluginsSenders}
                            />
                            <ul style={{ margin: "10px 0 0 0" }}>
                              {this.state.showSendersListError &&
                                Object.keys(this.state.sendersErrors).map(
                                  (keyName, keyIndex) => {
                                    return (
                                      <li
                                        key={keyIndex}
                                        className="validation-error"
                                      >
                                        {this.state.sendersErrors[keyName]}
                                      </li>
                                    );
                                  }
                                )}
                            </ul>
                          </div>
                        )}
                      </TabPane>
                      <TabPane tabId="4">
                        <div
                          className="content_block fill col-lg-12 col-md-12 col-sm-12 col-xs-12"
                          style={{ padding: "0", width: "100%" }}
                        >
                          <div>
                            {config.selectedCustomerChildList &&
                              this.generateChildCustomerGrid(
                                config.selectedCustomerChildList
                              )}
                          </div>
                        </div>
                      </TabPane>
                    </TabContent>
                  </div>
                </div>
              </div>
            )}
            {!config.selectedCustomerInfo && !config.isNewCustomer && (
              <div className="empty-text">
                <p>
                  Please choose a customer from the list or press Add button to
                  add new customer.
                </p>
              </div>
            )}
          </div>
        </div>
        <SaveCustomerConfirm
          showLoader={this.showLoader}
          hideLoader={this.hideLoader}
          handleSelectCustomer={this.handleSelectCustomer}
          saveCustomer={this.saveCustomer}
        />
        <Modal
          isOpen={this.state.modalHistory}
          toggle={this.toggleModalHistory}
        >
          <ModalHeader toggle={this.toggleModalHistory}>History</ModalHeader>
          <ModalBody>
            <div className="table w_subsearch_res_body">
              <div className="tr th">
                <div className="td" style={{ flexGrow: "3" }}>
                  Date
                </div>
                <div className="td" style={{ flexGrow: "3" }}>
                  Username
                </div>
                <div className="td">&nbsp;</div>
              </div>
              {this.state.selectedCustomerHistory &&
                this.state.selectedCustomerHistory.length > 0 &&
                this.state.selectedCustomerHistory.map((row, i) => {
                  return (
                    <div key={i} className="tr">
                      <div className="td" style={{ flexGrow: "3" }}>
                        <div className="w_subsearch_res_text">
                          <span style={{ marginLeft: "4px" }}>
                            {row.creationDate
                              ? moment
                                  .utc(row.creationDate, moment.ISO_8601)
                                  .format("DD-MM-YYYY HH:mm:ss")
                              : "n/a"}
                          </span>
                        </div>
                      </div>
                      <div className="td" style={{ flexGrow: "3" }}>
                        <div
                          className="w_subsearch_res_text"
                          data-container="body"
                        >
                          {row.author}
                        </div>
                      </div>
                      <div className="td">
                        <div
                          className="w_subsearch_res_text"
                          role="button"
                          data-container="body"
                        >
                          <button
                            type="button"
                            onClick={(e) => {
                              this.handleOpenFullEventClick(e, row.dataObject);
                            }}
                            style={{ padding: "1px 6px" }}
                            className="btn btn-default btn-xs w_p_action_sub"
                            title="Data object"
                          >
                            <span
                              className="fa fa-folder-open"
                              aria-hidden="true"
                            />
                          </button>
                        </div>
                      </div>
                    </div>
                  );
                })}
              {this.state.selectedCustomerHistory.length === 0 && (
                <div className="tr">
                  <div
                    className="td justify-content-center"
                    style={{ flexGrow: "2" }}
                  >
                    <span>{translate("NoResults")}</span>
                  </div>
                </div>
              )}
            </div>
          </ModalBody>
          <ModalFooter className="text-center">
            <button
              type="button"
              className="btn btn-secondary"
              onClick={this.toggleModalHistory}
            >
              {translate("Close")}
            </button>
          </ModalFooter>
        </Modal>
        <Modal
          style={{ width: "70vw", maxWidth: "95vw" }}
          isOpen={this.state.fullEventModal}
          toggle={this.toggleFullEventModal}
        >
          <ModalHeader toggle={this.toggleFullEventModal}>Details</ModalHeader>
          <ModalBody>
            <ReactJson
              src={this.state.eventJsonObj}
              enableClipboard
              displayDataTypes={false}
            />
          </ModalBody>
        </Modal>
        <Modal isOpen={this.state.modalBind} toggle={this.toggleModalBind}>
          <ModalHeader toggle={this.toggleModalBind}>
            <div
              style={{
                textAlign: "center",
                fontSize: "14px",
                lineHeight: "1.2",
                padding: "0 30px",
              }}
            >
              Unbound (unenriched) data related to this company (according
              LegacyIds table) found. In ideal case there should be 0 count in
              every row
            </div>
          </ModalHeader>
          <ModalBody>
            <div className="table w_subsearch_res_body">
              <div className="tr th">
                <div className="td" style={{ flexGrow: "3" }}>
                  Type
                </div>
                <div className="td">Count</div>
              </div>
              <div className="tr">
                <div className="td" style={{ flexGrow: "3" }}>
                  <div className="w_subsearch_res_text">Events</div>
                </div>
                <div className="td">
                  <div className="w_subsearch_res_text" data-container="body">
                    {this.state.bindUpdatedEventCount}
                  </div>
                </div>
              </div>
              <div className="tr">
                <div className="td" style={{ flexGrow: "3" }}>
                  <div className="w_subsearch_res_text">
                    Dashboard volume items
                  </div>
                </div>
                <div className="td">
                  <div className="w_subsearch_res_text" data-container="body">
                    {this.state.bindUpdatedDashboardVolumeCount}
                  </div>
                </div>
              </div>
              <div className="tr">
                <div className="td" style={{ flexGrow: "3" }}>
                  <div className="w_subsearch_res_text">
                    File buckets (files)
                  </div>
                </div>
                <div className="td">
                  <div className="w_subsearch_res_text" data-container="body">
                    {this.state.bindUpdatedFilebucketCount}
                  </div>
                </div>
              </div>
              <div className="tr">
                <div className="td" style={{ flexGrow: "3" }}>
                  <div className="w_subsearch_res_text">Parked documents</div>
                </div>
                <div className="td">
                  <div className="w_subsearch_res_text" data-container="body">
                    {this.state.bindUpdatedParkedDocumentCount}
                  </div>
                </div>
              </div>
              <div className="tr">
                <div className="td" style={{ flexGrow: "3" }}>
                  <div className="w_subsearch_res_text">DOBS</div>
                </div>
                <div className="td">
                  <div className="w_subsearch_res_text" data-container="body">
                    {this.state.bindUpdatedDobsCount}
                  </div>
                </div>
              </div>
            </div>
            <div>
              <Button
                color="primary"
                className="EventSearchSubmit"
                disabled={!this.state.enableBindDataDialog}
                onClick={this.handleStartDataBindingBtn}
                style={{ float: "left", width: "140px" }}
              >
                {translate("BindData")}
              </Button>
            </div>
          </ModalBody>
          <ModalFooter className="text-center">
            <button
              type="button"
              className="btn btn-secondary"
              onClick={this.toggleModalBind}
            >
              {translate("Close")}
            </button>
          </ModalFooter>
        </Modal>
      </div>
    );
  }
}
const required = (value) => {
  if (!value.toString().trim().length) {
    // We can return string or jsx as the 'error' prop for the validated Component
    return <div className="validation-error">Required</div>;
  }
};

const lt = (value, props) => {
  if (!value.toString().trim().length > props.maxLength) {
    return (
      <div className="validation-error">
        The value exceeded {props.maxLength} symbols.
      </div>
    );
  }
};

function mapStateToProps(state) {
  const { config, locale } = state;
  return {
    config,
    userLDAPUserRights: state.authentication.userLDAPUserRights,
    translate: getTranslate(locale),
  };
}

const connectedConfiguration = connect(mapStateToProps)(
  withRouter(Configuration)
);
export { connectedConfiguration as Configuration };
